export const teamsData = {
    "teamA": {
        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
        "name": "Chiefs",
        "market": "Kansas City",
        "alias": "KC",
        "sr_id": "sr:competitor:4422",
        "founded": 1960,
        "owner": "Clark Hunt",
        "general_manager": "Brett Veach",
        "president": "Mark Donovan",
        "mascot": "K. C. Wolf",
        "championships_won": 4,
        "championship_seasons": "1969, 2019, 2022, 2023",
        "conference_titles": 7,
        "division_titles": 16,
        "playoff_appearances": 26,
        "franchise": {
            "id": "5d239f9e-ef6a-46a6-83c2-94500fd119be",
            "name": "Chiefs",
            "alias": "KC"
        },
        "venue": {
            "id": "2ec4c411-dac2-403d-b091-6b6aa4a0a914",
            "name": "GEHA Field at Arrowhead Stadium",
            "city": "Kansas City",
            "state": "MO",
            "country": "USA",
            "zip": "64129",
            "address": "One Arrowhead Drive",
            "capacity": 76416,
            "surface": "turf",
            "roof_type": "outdoor",
            "sr_id": "sr:venue:8189",
            "location": {
                "lat": "39.049019",
                "lng": "-94.484140"
            }
        },
        "division": {
            "id": "324decdd-aa1b-4074-8958-c009d8fac31a",
            "name": "AFC West",
            "alias": "AFC_WEST"
        },
        "conference": {
            "id": "1bdefe12-6cb2-4d6a-b208-b04602ae79c3",
            "name": "AFC",
            "alias": "AFC"
        },
        "coaches": [
            {
                "id": "11781d7e-5d9c-43b9-b597-bc6f0461216f",
                "full_name": "Matt Nagy",
                "first_name": "Matt",
                "last_name": "Nagy",
                "position": "Offensive Coordinator"
            },
            {
                "id": "3001ea20-e8f8-11ef-bcd3-b58775256daf",
                "full_name": "Dave Toub",
                "first_name": "Dave",
                "last_name": "Toub",
                "position": "Special Teams Coordinator"
            },
            {
                "id": "3af34d1f-d056-4d3b-8457-d27613275bec",
                "full_name": "Andy Reid",
                "first_name": "Andy",
                "last_name": "Reid",
                "position": "Head Coach"
            },
            {
                "id": "5b8e57f4-6cc0-469d-9fe3-8771b0e6dc87",
                "full_name": "Steve Spagnuolo",
                "first_name": "Steve",
                "last_name": "Spagnuolo",
                "position": "Defensive Coordinator"
            }
        ],
        "players": [
            {
                "id": "04648fce-0bba-40d4-98c0-e18c48e32567",
                "name": "Omarr Norman-Lott",
                "last_name": "Norman-Lott",
                "first_name": "Omarr",
                "abbr_name": "O.Norman-Lott",
                "birth_date": "2002-03-11",
                "weight": 291,
                "height": 73,
                "position": "DT",
                "birth_place": "North Highlands, CA, USA",
                "high_school": "Grant (CA)",
                "college": "Tennessee",
                "college_conf": "Southeastern Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 2,
                    "number": 63,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "0818d720-2620-11f0-b083-abaeadb72a30",
                "name": "Dante Wright",
                "last_name": "Wright",
                "first_name": "Dante",
                "abbr_name": "D.Wright",
                "weight": 180,
                "height": 69,
                "position": "WR",
                "birth_place": "Navarre, FL, USA",
                "high_school": "Navarre",
                "college": "Temple",
                "college_conf": "American Athletic Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "0ef0d0ca-2d2d-455b-ab63-a20c01303e37",
                "name": "Kareem Hunt",
                "last_name": "Hunt",
                "first_name": "Kareem",
                "abbr_name": "K.Hunt",
                "birth_date": "1995-08-06",
                "weight": 216,
                "height": 71,
                "position": "RB",
                "birth_place": "Willoughby, OH, USA",
                "high_school": "South (OH)",
                "college": "Toledo",
                "college_conf": "Mid-American Conference",
                "rookie_year": 2017,
                "status": "ACT",
                "sr_id": "sr:player:1129873",
                "experience": 8,
                "draft": {
                    "year": 2017,
                    "round": 3,
                    "number": 86,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "0ef78810-a38b-4444-b3b9-fb8b293c567d",
                "name": "Jalen Royals",
                "last_name": "Royals",
                "first_name": "Jalen",
                "abbr_name": "J.Royals",
                "birth_date": "2003-02-18",
                "weight": 205,
                "height": 72,
                "position": "WR",
                "birth_place": "Powder Springs, GA, USA",
                "high_school": "Hillgrove (GA)",
                "college": "Utah State",
                "college_conf": "Mountain West Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 4,
                    "number": 133,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "0f9883f3-bff3-4247-8e90-7df2066070c6",
                "name": "Felix Anudike-Uzomah",
                "jersey": "97",
                "last_name": "Anudike-Uzomah",
                "first_name": "Felix",
                "abbr_name": "F.Anudike-Uzomah",
                "birth_date": "2002-01-24",
                "weight": 255,
                "height": 76,
                "position": "DE",
                "birth_place": "Kansas City, MO, USA",
                "high_school": "Lee's Summit (MO)",
                "college": "Kansas State",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:2066993",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 1,
                    "number": 31,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "11000880-261c-11f0-baa4-e9f1e309c647",
                "name": "Coziah Izzard",
                "last_name": "Izzard",
                "first_name": "Coziah",
                "abbr_name": "C.Izzard",
                "weight": 305,
                "height": 75,
                "position": "DT",
                "birth_place": "Columbia, MD, USA",
                "high_school": "DeMatha Catholic (MD)",
                "college": "Penn State",
                "college_conf": "Big Ten Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "11cad59d-90dd-449c-a839-dddaba4fe16c",
                "name": "Patrick Mahomes",
                "jersey": "15",
                "last_name": "Mahomes",
                "first_name": "Patrick",
                "abbr_name": "P.Mahomes",
                "birth_date": "1995-09-17",
                "weight": 225,
                "height": 74,
                "position": "QB",
                "birth_place": "Tyler, TX, USA",
                "high_school": "Whitehouse (TX)",
                "college": "Texas Tech",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2017,
                "status": "ACT",
                "sr_id": "sr:player:1129537",
                "experience": 8,
                "draft": {
                    "year": 2017,
                    "round": 1,
                    "number": 10,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "12665370-23a4-11f0-9e85-b92dafb299c8",
                "name": "Jacobe Covington",
                "last_name": "Covington",
                "first_name": "Jacobe",
                "abbr_name": "J.Covington",
                "weight": 200,
                "height": 74,
                "position": "CB",
                "birth_place": "Chandler, AZ, USA",
                "high_school": "Saguaro (AZ)",
                "college": "USC",
                "college_conf": "Big Ten Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "146abdb0-239e-11f0-8453-2d7672a711cb",
                "name": "Glendon Miller",
                "last_name": "Miller",
                "first_name": "Glendon",
                "abbr_name": "G.Miller",
                "weight": 206,
                "height": 74,
                "position": "SAF",
                "birth_place": "Orange Park, FL, USA",
                "high_school": "Ridgeview (FL)",
                "college": "Maryland",
                "college_conf": "Big Ten Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "14926860-abef-45a9-b8f6-e66103ca6029",
                "name": "Bailey Zappe",
                "last_name": "Zappe",
                "first_name": "Bailey",
                "abbr_name": "B.Zappe",
                "birth_date": "1999-04-26",
                "weight": 220,
                "height": 73,
                "position": "QB",
                "birth_place": "Victoria, TX, USA",
                "high_school": "Victoria East (TX)",
                "college": "Western Kentucky",
                "college_conf": "Conference USA",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1276558",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 4,
                    "number": 137,
                    "team": {
                        "id": "97354895-8c77-4fd4-a860-32e62ea7382a",
                        "name": "Patriots",
                        "market": "New England",
                        "alias": "NE",
                        "sr_id": "sr:competitor:4424"
                    }
                }
            },
            {
                "id": "14b8cda0-ec39-11ed-aeaf-cb0dc6206dc5",
                "name": "Cam Jones",
                "jersey": "44",
                "last_name": "Jones",
                "first_name": "Cam",
                "abbr_name": "C.Jones",
                "birth_date": "1999-10-21",
                "weight": 227,
                "height": 74,
                "position": "LB",
                "birth_place": "Memphis, TN, USA",
                "high_school": "St. Benedict at Auburndale (TN)",
                "college": "Indiana",
                "college_conf": "Big Ten Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1435041",
                "experience": 2
            },
            {
                "id": "15ff4e92-dad4-4ff8-ba50-97c68d85f1c1",
                "name": "Hunter Nourzad",
                "jersey": "60",
                "last_name": "Nourzad",
                "first_name": "Hunter",
                "abbr_name": "H.Nourzad",
                "birth_date": "2000-11-26",
                "weight": 317,
                "height": 75,
                "position": "OL",
                "birth_place": "Marietta, GA, USA",
                "high_school": "The Walker School (GA)",
                "college": "Penn State",
                "college_conf": "Big Ten Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:1543005",
                "experience": 0,
                "draft": {
                    "year": 2024,
                    "round": 5,
                    "number": 159,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "170d9d12-0595-4636-9b42-822ff93a6d94",
                "name": "Robert Rochell",
                "last_name": "Rochell",
                "first_name": "Robert",
                "abbr_name": "R.Rochell",
                "birth_date": "1998-04-26",
                "weight": 195,
                "height": 74,
                "position": "CB",
                "birth_place": "Shreveport, LA, USA",
                "high_school": "Fair Park (LA)",
                "college": "Central Arkansas",
                "college_conf": "ASUN Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2198722",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 4,
                    "number": 130,
                    "team": {
                        "id": "2eff2a03-54d4-46ba-890e-2bc3925548f3",
                        "name": "Rams",
                        "market": "Los Angeles",
                        "alias": "LA",
                        "sr_id": "sr:competitor:4387"
                    }
                }
            },
            {
                "id": "172b40b0-07cf-11ef-97d8-45d7b9ff0b1c",
                "name": "Ethan Driskell",
                "jersey": "75",
                "last_name": "Driskell",
                "first_name": "Ethan",
                "abbr_name": "E.Driskell",
                "birth_date": "2000-06-29",
                "weight": 313,
                "height": 80,
                "position": "OT",
                "birth_place": "Louisville, KY, USA",
                "college": "Marshall",
                "college_conf": "Sun Belt Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:1839950",
                "experience": 0
            },
            {
                "id": "1c8a4510-786c-4bc2-a9e9-e491b688206f",
                "name": "Skyy Moore",
                "jersey": "24",
                "last_name": "Moore",
                "first_name": "Skyy",
                "abbr_name": "S.Moore",
                "birth_date": "2000-09-10",
                "weight": 195,
                "height": 70,
                "position": "WR",
                "birth_place": "New Kensington, PA, USA",
                "high_school": "Shady Side Academy (PA)",
                "college": "Western Michigan",
                "college_conf": "Mid-American Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1859714",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 2,
                    "number": 54,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "1d70c710-261e-11f0-9676-c51a3b6b08fe",
                "name": "Will Brooks",
                "last_name": "Brooks",
                "first_name": "Will",
                "abbr_name": "W.Brooks",
                "birth_date": "2001-10-25",
                "weight": 206,
                "height": 73,
                "position": "SAF",
                "birth_place": "Birmingham, AL, USA",
                "high_school": "Vestavia Hills (AL)",
                "college": "Tennessee",
                "college_conf": "Southeastern Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "1f66d210-23aa-11f0-8981-b32f195cd5a2",
                "name": "Dalton Cooper",
                "last_name": "Cooper",
                "first_name": "Dalton",
                "abbr_name": "D.Cooper",
                "birth_date": "2001-03-15",
                "weight": 315,
                "height": 79,
                "position": "OT",
                "birth_place": "Prague, OK, USA",
                "high_school": "Prague (OK)",
                "college": "Oklahoma State",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "21a56bce-7c06-44d7-b641-99f499111739",
                "name": "Bryan Cook",
                "jersey": "6",
                "last_name": "Cook",
                "first_name": "Bryan",
                "abbr_name": "B.Cook",
                "birth_date": "1999-09-07",
                "weight": 206,
                "height": 73,
                "position": "SAF",
                "birth_place": "Cincinnati, OH, USA",
                "high_school": "Mount Healthy (OH)",
                "college": "Cincinnati",
                "college_conf": "American Athletic Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1258562",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 2,
                    "number": 62,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "254842eb-c5ad-4e57-8679-3df5a674a14e",
                "name": "Darius Rush",
                "jersey": "46",
                "last_name": "Rush",
                "first_name": "Darius",
                "abbr_name": "D.Rush",
                "birth_date": "2000-02-22",
                "weight": 198,
                "height": 74,
                "position": "CB",
                "birth_place": "Kingstree, SC, USA",
                "high_school": "C.E. Murray (SC)",
                "college": "South Carolina",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1413345",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 5,
                    "number": 138,
                    "team": {
                        "id": "82cf9565-6eb9-4f01-bdbd-5aa0d472fcd9",
                        "name": "Colts",
                        "market": "Indianapolis",
                        "alias": "IND",
                        "sr_id": "sr:competitor:4421"
                    }
                }
            },
            {
                "id": "299cb403-1cea-48da-baaa-b55510a6b78b",
                "name": "Blake Lynch",
                "last_name": "Lynch",
                "first_name": "Blake",
                "abbr_name": "B.Lynch",
                "birth_date": "1997-02-14",
                "weight": 225,
                "height": 75,
                "position": "LB",
                "birth_place": "Gilmer, TX, USA",
                "high_school": "Gilmer (TX)",
                "college": "Baylor",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2020,
                "status": "ACT",
                "sr_id": "sr:player:2040673",
                "experience": 3
            },
            {
                "id": "3170164a-1718-4a39-9ef2-e18104e35fef",
                "name": "Brashard Smith",
                "last_name": "Smith",
                "first_name": "Brashard",
                "abbr_name": "B.Smith",
                "birth_date": "2003-04-11",
                "weight": 194,
                "height": 69,
                "position": "RB",
                "birth_place": "Richmond Heights, FL, USA",
                "high_school": "Miami Palmetto (FL)",
                "college": "SMU",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 7,
                    "number": 228,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "3577a340-07db-11ef-91e3-2f73c380b376",
                "name": "Fabien Lovett Sr.",
                "jersey": "96",
                "last_name": "Lovett",
                "first_name": "Fabien",
                "abbr_name": "F.Lovett",
                "birth_date": "1999-12-05",
                "weight": 316,
                "height": 75,
                "position": "DT",
                "birth_place": "Vicksburg, MS, USA",
                "high_school": "Olive Branch (MS)",
                "college": "Florida State",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:1413395",
                "name_suffix": "Sr.",
                "experience": 0
            },
            {
                "id": "358bda61-ccb6-443a-a51c-3b14b3cadf22",
                "name": "Trent McDuffie",
                "jersey": "22",
                "last_name": "McDuffie",
                "first_name": "Trent",
                "abbr_name": "T.McDuffie",
                "birth_date": "2000-09-13",
                "weight": 193,
                "height": 71,
                "position": "CB",
                "birth_place": "Westminster, CA, USA",
                "high_school": "St. John Bosco (CA)",
                "college": "Washington",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1696193",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 1,
                    "number": 21,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "370a8ac8-f6f4-44ef-91b3-a65ab79ec314",
                "name": "Jaylon Moore",
                "jersey": "77",
                "last_name": "Moore",
                "first_name": "Jaylon",
                "abbr_name": "J.Moore",
                "birth_date": "1998-01-09",
                "weight": 311,
                "height": 76,
                "position": "OL",
                "birth_place": "Detroit, MI, USA",
                "high_school": "Consortium (MI)",
                "college": "Western Michigan",
                "college_conf": "Mid-American Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2197870",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 5,
                    "number": 155,
                    "team": {
                        "id": "f0e724b0-4cbf-495a-be47-013907608da9",
                        "name": "49ers",
                        "market": "San Francisco",
                        "alias": "SF",
                        "sr_id": "sr:competitor:4389"
                    }
                }
            },
            {
                "id": "382bf27a-8afb-4ffe-b7b8-9a960b98049a",
                "name": "Trey Smith",
                "jersey": "65",
                "last_name": "Smith",
                "first_name": "Trey",
                "abbr_name": "T.Smith",
                "birth_date": "1999-06-16",
                "weight": 321,
                "height": 78,
                "position": "G",
                "birth_place": "Humboldt, TN, USA",
                "high_school": "University (TN)",
                "college": "Tennessee",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2197606",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 6,
                    "number": 226,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "3a25c037-fa30-4740-b742-ec8e4f1a2a25",
                "name": "Isiah Pacheco",
                "jersey": "10",
                "last_name": "Pacheco",
                "first_name": "Isiah",
                "abbr_name": "I.Pacheco",
                "birth_date": "1999-03-02",
                "weight": 216,
                "height": 70,
                "position": "RB",
                "birth_place": "Vineland, NJ, USA",
                "high_school": "Vineland South (NJ)",
                "college": "Rutgers",
                "college_conf": "Big Ten Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1436298",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 7,
                    "number": 251,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "3e4f799d-5567-4239-9513-86a16a674073",
                "name": "Jaden Hicks",
                "jersey": "21",
                "last_name": "Hicks",
                "first_name": "Jaden",
                "abbr_name": "J.Hicks",
                "birth_date": "2002-08-16",
                "weight": 215,
                "height": 73,
                "position": "DB",
                "birth_place": "Las Vegas, NV, USA",
                "high_school": "Bishop Gorman (NV)",
                "college": "Washington State",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:2155590",
                "experience": 0,
                "draft": {
                    "year": 2024,
                    "round": 4,
                    "number": 133,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "46190530-23ab-11f0-a8c1-91b88a8cabac",
                "name": "Jake Briningstool",
                "last_name": "Briningstool",
                "first_name": "Jake",
                "abbr_name": "J.Briningstool",
                "birth_date": "2002-12-09",
                "weight": 230,
                "height": 78,
                "position": "TE",
                "birth_place": "Brentwood, TN, USA",
                "high_school": "Ravenwood (TN)",
                "college": "Clemson",
                "college_conf": "Southeastern Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "47128e20-2621-11f0-b1a6-031de407737a",
                "name": "Tre Watson",
                "last_name": "Watson",
                "first_name": "Tre",
                "abbr_name": "T.Watson",
                "weight": 250,
                "height": 77,
                "position": "TE",
                "birth_place": "Rio Rancho, NM, USA",
                "high_school": "Cleveland (NM)",
                "college": "Texas A&M",
                "college_conf": "Southeastern Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "4ceb866c-8eaf-49b5-9043-56228e43a2e5",
                "name": "Harrison Butker",
                "jersey": "7",
                "last_name": "Butker",
                "first_name": "Harrison",
                "abbr_name": "H.Butker",
                "birth_date": "1995-07-14",
                "weight": 205,
                "height": 76,
                "position": "K",
                "birth_place": "Decatur, GA, USA",
                "high_school": "Westminster (GA)",
                "college": "Georgia Tech",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2017,
                "status": "ACT",
                "sr_id": "sr:player:1130067",
                "experience": 8,
                "draft": {
                    "year": 2017,
                    "round": 7,
                    "number": 233,
                    "team": {
                        "id": "f14bf5cc-9a82-4a38-bc15-d39f75ed5314",
                        "name": "Panthers",
                        "market": "Carolina",
                        "alias": "CAR",
                        "sr_id": "sr:competitor:4415"
                    }
                }
            },
            {
                "id": "52b850b0-ec3b-11ed-aeaf-cb0dc6206dc5",
                "name": "Nikko Remigio",
                "jersey": "81",
                "last_name": "Remigio",
                "first_name": "Nikko",
                "abbr_name": "N.Remigio",
                "birth_date": "1999-11-04",
                "weight": 187,
                "height": 69,
                "position": "WR",
                "birth_place": "Orange, CA, USA",
                "high_school": "Mater Dei (CA)",
                "college": "Fresno State",
                "college_conf": "Mountain West Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1439004",
                "experience": 1
            },
            {
                "id": "52e049b1-0a7a-4e7f-9866-d2848e9cc478",
                "name": "Xavier Worthy",
                "jersey": "1",
                "last_name": "Worthy",
                "first_name": "Xavier",
                "abbr_name": "X.Worthy",
                "birth_date": "2003-04-27",
                "weight": 165,
                "height": 71,
                "position": "WR",
                "birth_place": "Fresno, CA, USA",
                "high_school": "Central East (CA)",
                "college": "Texas",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:2151630",
                "experience": 0,
                "draft": {
                    "year": 2024,
                    "round": 1,
                    "number": 28,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "55c491d6-7721-45b4-968c-284448bf8c12",
                "name": "Matt Araiza",
                "jersey": "14",
                "last_name": "Araiza",
                "first_name": "Matt",
                "abbr_name": "M.Araiza",
                "birth_date": "2000-05-16",
                "weight": 200,
                "height": 73,
                "position": "P",
                "birth_place": "San Diego, CA, USA",
                "high_school": "Rancho Bernardo (CA)",
                "college": "San Diego State",
                "college_conf": "Mountain West Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1477144",
                "experience": 1,
                "draft": {
                    "year": 2022,
                    "round": 6,
                    "number": 180,
                    "team": {
                        "id": "768c92aa-75ff-4a43-bcc0-f2798c2e1724",
                        "name": "Bills",
                        "market": "Buffalo",
                        "alias": "BUF",
                        "sr_id": "sr:competitor:4376"
                    }
                }
            },
            {
                "id": "56312980-07cc-11ef-ae1a-ef16ff05bbda",
                "name": "Carson Steele",
                "jersey": "42",
                "last_name": "Steele",
                "first_name": "Carson",
                "abbr_name": "C.Steele",
                "birth_date": "2002-10-21",
                "weight": 228,
                "height": 72,
                "position": "RB",
                "birth_place": "Greenwood, IN, USA",
                "high_school": "Center Grove (IN)",
                "college": "UCLA",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:2205520",
                "experience": 0
            },
            {
                "id": "5769d380-23a3-11f0-87d7-11fc3dd0df26",
                "name": "Eddie Czaplicki",
                "last_name": "Czaplicki",
                "first_name": "Eddie",
                "abbr_name": "E.Czaplicki",
                "weight": 207,
                "height": 73,
                "position": "P",
                "birth_place": "Charlotte, NC, USA",
                "high_school": "Providence (NC)",
                "college": "USC",
                "college_conf": "Big Ten Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "5a99d26a-0c11-4705-99de-8c4960d6fbc9",
                "name": "Siaki Ika",
                "jersey": "99",
                "last_name": "Ika",
                "first_name": "Siaki",
                "abbr_name": "S.Ika",
                "birth_date": "2000-11-07",
                "weight": 335,
                "height": 75,
                "position": "DT",
                "birth_place": "Salt Lake City, UT, USA",
                "high_school": "East (UT)",
                "college": "Baylor",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1694055",
                "experience": 1,
                "draft": {
                    "year": 2023,
                    "round": 3,
                    "number": 98,
                    "team": {
                        "id": "d5a2eb42-8065-4174-ab79-0a6fa820e35e",
                        "name": "Browns",
                        "market": "Cleveland",
                        "alias": "CLE",
                        "sr_id": "sr:competitor:4417"
                    }
                }
            },
            {
                "id": "5b1803e0-23a2-11f0-aa42-af87cf00c6ae",
                "name": "Brandon George",
                "last_name": "George",
                "first_name": "Brandon",
                "abbr_name": "B.George",
                "weight": 240,
                "height": 75,
                "position": "LB",
                "birth_place": "Reading, PA, USA",
                "high_school": "Berks Catholic (PA)",
                "college": "Pittsburgh",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "5e40ece0-ce0e-11ec-8f7c-f5226825ea6a",
                "name": "Mike Caliendo",
                "jersey": "66",
                "last_name": "Caliendo",
                "first_name": "Mike",
                "abbr_name": "M.Caliendo",
                "birth_date": "1997-10-21",
                "weight": 301,
                "height": 76,
                "position": "OL",
                "birth_place": "Brookfield, WI, USA",
                "high_school": "Brookfield East (WI)",
                "college": "Western Michigan",
                "college_conf": "Mid-American Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1224510",
                "experience": 2
            },
            {
                "id": "6971dfd0-ce0d-11ec-8f7c-f5226825ea6a",
                "name": "Jack Cochrane",
                "jersey": "43",
                "last_name": "Cochrane",
                "first_name": "Jack",
                "abbr_name": "J.Cochrane",
                "birth_date": "1999-02-09",
                "weight": 236,
                "height": 75,
                "position": "LB",
                "birth_place": "Mount Vernon, IA, USA",
                "high_school": "Mount Vernon (IA)",
                "college": "South Dakota",
                "college_conf": "Missouri Valley Football Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1245332",
                "experience": 3
            },
            {
                "id": "6e03aec0-23a0-11f0-900b-373ee4a86a01",
                "name": "Mac Dalena",
                "last_name": "Dalena",
                "first_name": "Mac",
                "abbr_name": "M.Dalena",
                "weight": 180,
                "height": 71,
                "position": "WR",
                "birth_place": "Fresno, CA, USA",
                "high_school": "San Joaquin Memorial (CA)",
                "college": "Fresno State",
                "college_conf": "Mountain West Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "6f3a80b4-9b7b-4429-aec1-bc508ef8e0e6",
                "name": "Kingsley Suamataia",
                "jersey": "76",
                "last_name": "Suamataia",
                "first_name": "Kingsley",
                "abbr_name": "K.Suamataia",
                "birth_date": "2003-01-18",
                "weight": 326,
                "height": 76,
                "position": "T",
                "birth_place": "Orem, UT, USA",
                "high_school": "Orem (UT)",
                "college": "BYU",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:2154946",
                "experience": 0,
                "draft": {
                    "year": 2024,
                    "round": 2,
                    "number": 63,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "7078cdfc-032b-4f85-8b4b-720f926ba1cb",
                "name": "Chris Oladokun",
                "jersey": "19",
                "last_name": "Oladokun",
                "first_name": "Chris",
                "abbr_name": "C.Oladokun",
                "birth_date": "1997-09-03",
                "weight": 213,
                "height": 73,
                "position": "QB",
                "birth_place": "Tampa, FL, USA",
                "high_school": "Sickles (FL)",
                "college": "South Dakota State",
                "college_conf": "Missouri Valley Football Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1180192",
                "experience": 1,
                "draft": {
                    "year": 2022,
                    "round": 7,
                    "number": 241,
                    "team": {
                        "id": "cb2f9f1f-ac67-424e-9e72-1475cb0ed398",
                        "name": "Steelers",
                        "market": "Pittsburgh",
                        "alias": "PIT",
                        "sr_id": "sr:competitor:4345"
                    }
                }
            },
            {
                "id": "74cda487-2026-42e0-ae32-77f3502cfb11",
                "name": "Tyquan Thornton",
                "jersey": "19",
                "last_name": "Thornton",
                "first_name": "Tyquan",
                "abbr_name": "T.Thornton",
                "birth_date": "2000-08-07",
                "weight": 185,
                "height": 74,
                "position": "WR",
                "birth_place": "Miami, FL, USA",
                "high_school": "Booker T. Washington (FL)",
                "college": "Baylor",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1435193",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 2,
                    "number": 50,
                    "team": {
                        "id": "97354895-8c77-4fd4-a860-32e62ea7382a",
                        "name": "Patriots",
                        "market": "New England",
                        "alias": "NE",
                        "sr_id": "sr:competitor:4424"
                    }
                }
            },
            {
                "id": "7c9c7800-69d0-459b-812b-a07ac48e9f2a",
                "name": "Robert Tonyan",
                "jersey": "49",
                "last_name": "Tonyan",
                "first_name": "Robert",
                "abbr_name": "R.Tonyan",
                "birth_date": "1994-04-30",
                "weight": 200,
                "height": 77,
                "position": "TE",
                "birth_place": "McHenry, IL, USA",
                "high_school": "McHenry East (IL)",
                "college": "Indiana State",
                "college_conf": "Missouri Valley Football Conference",
                "rookie_year": 2017,
                "status": "ACT",
                "sr_id": "sr:player:1134065",
                "experience": 7
            },
            {
                "id": "7d2f964c-1e5d-4f13-a169-62b4a9e35f2c",
                "name": "Nohl Williams",
                "last_name": "Williams",
                "first_name": "Nohl",
                "abbr_name": "N.Williams",
                "birth_date": "2002-09-23",
                "weight": 199,
                "height": 72,
                "position": "CB",
                "birth_place": "Ventura, CA, USA",
                "high_school": "Pacifica (CA)",
                "college": "California",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 3,
                    "number": 85,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "8385d8de-c682-4970-b657-13fd197d20db",
                "name": "Eric Scott Jr.",
                "jersey": "29",
                "last_name": "Scott",
                "first_name": "Eric",
                "abbr_name": "E.Scott",
                "birth_date": "1998-08-07",
                "weight": 197,
                "height": 72,
                "position": "CB",
                "birth_place": "Basehor, KS, USA",
                "high_school": "Basehor-Linwood (KS)",
                "college": "Southern Miss",
                "college_conf": "Conference USA",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1249612",
                "name_suffix": "Jr.",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 6,
                    "number": 178,
                    "team": {
                        "id": "e627eec7-bbae-4fa4-8e73-8e1d6bc5c060",
                        "name": "Cowboys",
                        "market": "Dallas",
                        "alias": "DAL",
                        "sr_id": "sr:competitor:4392"
                    }
                }
            },
            {
                "id": "83ad043c-d1e6-45b3-9e06-3f148538db46",
                "name": "Nick Bolton",
                "jersey": "32",
                "last_name": "Bolton",
                "first_name": "Nick",
                "abbr_name": "N.Bolton",
                "birth_date": "2000-03-10",
                "weight": 237,
                "height": 71,
                "position": "LB",
                "birth_place": "Frisco, TX, USA",
                "high_school": "Lone Star (TX)",
                "college": "Missouri",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2198068",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 2,
                    "number": 58,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "84daf110-2622-11f0-bca5-417408028ca8",
                "name": "Qualan Jones",
                "last_name": "Jones",
                "first_name": "Qualan",
                "abbr_name": "Q.Jones",
                "weight": 242,
                "height": 70,
                "position": "RB",
                "birth_place": "Cedar Hill, TX, USA",
                "college": "Stephen F. Austin",
                "college_conf": "Southland Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "8a410ba0-23a5-11f0-8d5d-1b4f09989b68",
                "name": "Elijhah Badger",
                "last_name": "Badger",
                "first_name": "Elijhah",
                "abbr_name": "E.Badger",
                "birth_date": "2001-08-15",
                "weight": 192,
                "height": 73,
                "position": "WR",
                "birth_place": "South Sacramento, CA, USA",
                "high_school": "Folsom (CA)",
                "college": "Florida",
                "college_conf": "Southeastern Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "8b9bc551-66bb-4948-849f-c0471caaeb19",
                "name": "Mike Pennel",
                "jersey": "69",
                "last_name": "Pennel",
                "first_name": "Mike",
                "abbr_name": "M.Pennel",
                "birth_date": "1991-05-09",
                "weight": 330,
                "height": 76,
                "position": "NT",
                "birth_place": "Topeka, KS, USA",
                "high_school": "Grandview (CO)",
                "college": "CSU-Pueblo",
                "college_conf": "Rocky Mountain Athletic Conference",
                "rookie_year": 2014,
                "status": "ACT",
                "sr_id": "sr:player:854870",
                "experience": 10
            },
            {
                "id": "8ba68abf-e9d2-4927-bf8d-476f271d840c",
                "name": "Elijah Mitchell",
                "jersey": "25",
                "last_name": "Mitchell",
                "first_name": "Elijah",
                "abbr_name": "E.Mitchell",
                "birth_date": "1998-05-02",
                "weight": 200,
                "height": 70,
                "position": "RB",
                "birth_place": "Erath, LA, USA",
                "high_school": "Erath (LA)",
                "college": "Louisiana",
                "college_conf": "Sun Belt Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:1180734",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 6,
                    "number": 194,
                    "team": {
                        "id": "f0e724b0-4cbf-495a-be47-013907608da9",
                        "name": "49ers",
                        "market": "San Francisco",
                        "alias": "SF",
                        "sr_id": "sr:competitor:4389"
                    }
                }
            },
            {
                "id": "8f07843a-6f68-409e-8cdf-1207f521b12a",
                "name": "Jawaan Taylor",
                "jersey": "74",
                "last_name": "Taylor",
                "first_name": "Jawaan",
                "abbr_name": "J.Taylor",
                "birth_date": "1997-11-25",
                "weight": 330,
                "height": 77,
                "position": "T",
                "birth_place": "Cocoa, FL, USA",
                "high_school": "Cocoa (FL)",
                "college": "Florida",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1217532",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 2,
                    "number": 35,
                    "team": {
                        "id": "f7ddd7fa-0bae-4f90-bc8e-669e4d6cf2de",
                        "name": "Jaguars",
                        "market": "Jacksonville",
                        "alias": "JAC",
                        "sr_id": "sr:competitor:4386"
                    }
                }
            },
            {
                "id": "938beb66-29b3-4bf5-ac8e-1b36d21fdcde",
                "name": "Jaylen Watson",
                "jersey": "35",
                "last_name": "Watson",
                "first_name": "Jaylen",
                "abbr_name": "J.Watson",
                "birth_date": "1998-09-17",
                "weight": 197,
                "height": 74,
                "position": "CB",
                "birth_place": "Augusta, GA, USA",
                "high_school": "Lucy C. Laney (GA)",
                "college": "Washington State",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:2343151",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 7,
                    "number": 243,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "9547fbb1-0d4f-4d9e-83b9-e2fa30463bb9",
                "name": "JuJu Smith-Schuster",
                "last_name": "Smith-Schuster",
                "first_name": "JuJu",
                "abbr_name": "J.Smith-Schuster",
                "birth_date": "1996-11-22",
                "weight": 215,
                "height": 73,
                "position": "WR",
                "birth_place": "Long Beach, CA, USA",
                "high_school": "Long Beach Poly (CA)",
                "college": "USC",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2017,
                "status": "ACT",
                "sr_id": "sr:player:1129761",
                "experience": 8,
                "draft": {
                    "year": 2017,
                    "round": 2,
                    "number": 62,
                    "team": {
                        "id": "cb2f9f1f-ac67-424e-9e72-1475cb0ed398",
                        "name": "Steelers",
                        "market": "Pittsburgh",
                        "alias": "PIT",
                        "sr_id": "sr:competitor:4345"
                    }
                }
            },
            {
                "id": "96c9a116-882b-4b6e-9975-a0f71d976152",
                "name": "C.J. Hanson",
                "jersey": "61",
                "last_name": "Hanson",
                "first_name": "C.J.",
                "abbr_name": "C.Hanson",
                "birth_date": "2001-03-03",
                "weight": 300,
                "height": 77,
                "position": "OL",
                "birth_place": "Wyckoff, NJ, USA",
                "high_school": "DePaul Catholic (NJ)",
                "college": "Holy Cross",
                "college_conf": "Patriot League Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:1747695",
                "experience": 0,
                "draft": {
                    "year": 2024,
                    "round": 7,
                    "number": 248,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "96d1c6e6-a450-476e-987b-c1e469c43f1b",
                "name": "Malik Herring",
                "jersey": "94",
                "last_name": "Herring",
                "first_name": "Malik",
                "abbr_name": "M.Herring",
                "birth_date": "1997-11-09",
                "weight": 275,
                "height": 75,
                "position": "DE",
                "birth_place": "Forsyth, GA, USA",
                "high_school": "Mary Persons (GA)",
                "college": "Georgia",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2198644",
                "experience": 4
            },
            {
                "id": "996a0607-8046-46c2-97a0-b94ff9f5a1c8",
                "name": "James Winchester",
                "jersey": "41",
                "last_name": "Winchester",
                "first_name": "James",
                "abbr_name": "J.Winchester",
                "birth_date": "1989-08-06",
                "weight": 209,
                "height": 75,
                "position": "LS",
                "birth_place": "Washington, OK, USA",
                "high_school": "Washington (OK)",
                "college": "Oklahoma",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2013,
                "status": "ACT",
                "sr_id": "sr:player:855674",
                "experience": 10
            },
            {
                "id": "99d77967-23b4-4554-adfc-f208e83c64ae",
                "name": "Josh Simmons",
                "last_name": "Simmons",
                "first_name": "Josh",
                "abbr_name": "J.Simmons",
                "birth_date": "2002-12-26",
                "weight": 317,
                "height": 76,
                "position": "OT",
                "birth_place": "San Diego, CA, USA",
                "high_school": "Helix (CA)",
                "college": "Ohio State",
                "college_conf": "Big Ten Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 1,
                    "number": 32,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "9b212b70-ccc3-4c77-ba73-09afeb929225",
                "name": "Keaontay Ingram",
                "jersey": "38",
                "last_name": "Ingram",
                "first_name": "Keaontay",
                "abbr_name": "K.Ingram",
                "birth_date": "1999-10-26",
                "weight": 220,
                "height": 72,
                "position": "RB",
                "birth_place": "Carthage, TX, USA",
                "high_school": "Carthage (TX)",
                "college": "USC",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1423101",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 6,
                    "number": 201,
                    "team": {
                        "id": "de760528-1dc0-416a-a978-b510d20692ff",
                        "name": "Cardinals",
                        "market": "Arizona",
                        "alias": "ARI",
                        "sr_id": "sr:competitor:4412"
                    }
                }
            },
            {
                "id": "9da6119d-b135-4b90-9f9d-7d08ab00b15d",
                "name": "Jerry Tillery",
                "last_name": "Tillery",
                "first_name": "Jerry",
                "abbr_name": "J.Tillery",
                "birth_date": "1996-10-08",
                "weight": 305,
                "height": 78,
                "position": "DL",
                "birth_place": "Shreveport, LA, USA",
                "high_school": "Evangel Christian Academy (LA)",
                "college": "Notre Dame",
                "college_conf": "Independent",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1188426",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 1,
                    "number": 28,
                    "team": {
                        "id": "1f6dcffb-9823-43cd-9ff4-e7a8466749b5",
                        "name": "Chargers",
                        "market": "Los Angeles",
                        "alias": "LAC",
                        "sr_id": "sr:competitor:4429"
                    }
                }
            },
            {
                "id": "9e487800-23a9-11f0-97c5-6362ab5bbdb8",
                "name": "Elijah Young",
                "last_name": "Young",
                "first_name": "Elijah",
                "abbr_name": "E.Young",
                "birth_date": "2001-09-14",
                "weight": 198,
                "height": 70,
                "position": "RB",
                "birth_place": "Knoxville, TN, USA",
                "high_school": "South Doyle (TN)",
                "college": "Western Kentucky",
                "college_conf": "Conference USA",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "9e9d2934-a273-4e39-a413-d991d083297b",
                "name": "Mike Danna",
                "jersey": "51",
                "last_name": "Danna",
                "first_name": "Mike",
                "abbr_name": "M.Danna",
                "birth_date": "1997-12-01",
                "weight": 257,
                "height": 74,
                "position": "DE",
                "birth_place": "Detroit, MI, USA",
                "high_school": "Warren De La Salle (MI)",
                "college": "Michigan",
                "college_conf": "Big Ten Conference",
                "rookie_year": 2020,
                "status": "ACT",
                "sr_id": "sr:player:2042667",
                "experience": 5,
                "draft": {
                    "year": 2020,
                    "round": 5,
                    "number": 177,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "9f8a0010-23a6-11f0-b68e-f3457b37f11f",
                "name": "Esa Pole",
                "last_name": "Pole",
                "first_name": "Esa",
                "abbr_name": "E.Pole",
                "weight": 319,
                "height": 79,
                "position": "OT",
                "birth_place": "Hayward, CA, USA",
                "high_school": "Mt. Eden",
                "college": "Washington State",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 0,
                "status": "ACT",
                "experience": 0
            },
            {
                "id": "a025e3d0-ea7e-11ed-b322-bbe6361075be",
                "name": "Chukwuebuka Godrick",
                "jersey": "72",
                "last_name": "Godrick",
                "first_name": "Chukwuebuka",
                "abbr_name": "C.Godrick",
                "birth_date": "2000-10-11",
                "weight": 293,
                "height": 77,
                "position": "OT",
                "birth_place": "Lagos,, NGA",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:2616049",
                "experience": 1
            },
            {
                "id": "a5a9fe33-3879-485e-8d9a-212d295133bd",
                "name": "Creed Humphrey",
                "jersey": "52",
                "last_name": "Humphrey",
                "first_name": "Creed",
                "abbr_name": "C.Humphrey",
                "birth_date": "1999-06-28",
                "weight": 302,
                "height": 76,
                "position": "C",
                "birth_place": "Shawnee, OK, USA",
                "high_school": "Shawnee (OK)",
                "college": "Oklahoma",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2197878",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 2,
                    "number": 63,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "a952a370-a43f-45ec-8371-0665f0b9551e",
                "name": "Jared Wiley",
                "jersey": "12",
                "last_name": "Wiley",
                "first_name": "Jared",
                "abbr_name": "J.Wiley",
                "birth_date": "2000-11-02",
                "weight": 249,
                "height": 78,
                "position": "TE",
                "birth_place": "Temple, TX, USA",
                "high_school": "Temple (TX)",
                "college": "TCU",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:1693967",
                "experience": 0,
                "draft": {
                    "year": 2024,
                    "round": 4,
                    "number": 131,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "abb612d4-f5b9-4644-b9ed-f13fa0da7e98",
                "name": "Deon Bush",
                "jersey": "26",
                "last_name": "Bush",
                "first_name": "Deon",
                "abbr_name": "D.Bush",
                "birth_date": "1993-08-14",
                "weight": 200,
                "height": 72,
                "position": "DB",
                "birth_place": "Miami, FL, USA",
                "high_school": "Columbus (FL)",
                "college": "Miami (FL)",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2016,
                "status": "ACT",
                "sr_id": "sr:player:1073908",
                "experience": 9,
                "draft": {
                    "year": 2016,
                    "round": 4,
                    "number": 124,
                    "team": {
                        "id": "7b112545-38e6-483c-a55c-96cf6ee49cb8",
                        "name": "Bears",
                        "market": "Chicago",
                        "alias": "CHI",
                        "sr_id": "sr:competitor:4391"
                    }
                }
            },
            {
                "id": "ae372a9d-6f85-4e37-a910-47fd77483ebc",
                "name": "Cole Christiansen",
                "jersey": "48",
                "last_name": "Christiansen",
                "first_name": "Cole",
                "abbr_name": "C.Christiansen",
                "birth_date": "1997-07-30",
                "weight": 230,
                "height": 73,
                "position": "LB",
                "birth_place": "Suffolk, VA, USA",
                "high_school": "Nansemond-Suffolk Academy (VA)",
                "college": "Army",
                "college_conf": "Independent",
                "rookie_year": 2020,
                "status": "ACT",
                "sr_id": "sr:player:1203386",
                "experience": 1
            },
            {
                "id": "afb1f463-400e-4bdb-9028-717a563ba6f4",
                "name": "George Karlaftis",
                "jersey": "56",
                "last_name": "Karlaftis",
                "first_name": "George",
                "abbr_name": "G.Karlaftis",
                "birth_date": "2001-04-03",
                "weight": 263,
                "height": 76,
                "position": "DE",
                "birth_place": "Athens,, GRC",
                "high_school": "West Lafayette (IN)",
                "college": "Purdue",
                "college_conf": "Big Ten Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1695453",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 1,
                    "number": 30,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "b2da84c5-e51c-47d8-bccc-888f8caaa8ad",
                "name": "Mike Edwards",
                "last_name": "Edwards",
                "first_name": "Mike",
                "abbr_name": "M.Edwards",
                "birth_date": "1996-05-18",
                "weight": 205,
                "height": 70,
                "position": "SAF",
                "birth_place": "Cincinnati, OH, USA",
                "high_school": "Winton Woods (OH)",
                "college": "Kentucky",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1183390",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 3,
                    "number": 99,
                    "team": {
                        "id": "4254d319-1bc7-4f81-b4ab-b5e6f3402b69",
                        "name": "Buccaneers",
                        "market": "Tampa Bay",
                        "alias": "TB",
                        "sr_id": "sr:competitor:4388"
                    }
                }
            },
            {
                "id": "b6d87372-98ca-4db0-81ec-86d44b21b32d",
                "name": "BJ Thompson",
                "jersey": "53",
                "last_name": "Thompson",
                "first_name": "BJ",
                "abbr_name": "B.Thompson",
                "birth_date": "1999-03-23",
                "weight": 243,
                "height": 78,
                "position": "DE",
                "birth_place": "England, AR, USA",
                "high_school": "England (AR)",
                "college": "Stephen F. Austin",
                "college_conf": "Western Athletic Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1258278",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 5,
                    "number": 166,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "b8192dc2-d5a9-4ff6-a0f3-eeb9fc6d9aa6",
                "name": "Wanya Morris",
                "jersey": "64",
                "last_name": "Morris",
                "first_name": "Wanya",
                "abbr_name": "W.Morris",
                "birth_date": "2000-10-10",
                "weight": 307,
                "height": 78,
                "position": "OL",
                "birth_place": "Grayson, GA, USA",
                "high_school": "Grayson (GA)",
                "college": "Oklahoma",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1527893",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 3,
                    "number": 92,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "be77723f-3d5a-47aa-9949-433993879a6f",
                "name": "Joshua Williams",
                "jersey": "2",
                "last_name": "Williams",
                "first_name": "Joshua",
                "abbr_name": "J.Williams",
                "birth_date": "1999-10-17",
                "weight": 193,
                "height": 75,
                "position": "CB",
                "birth_place": "Fayetteville, NC, USA",
                "high_school": "Jack Britt (NC)",
                "college": "Fayetteville State",
                "college_conf": "Central Intercollegiate Athletic Association",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:2343039",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 4,
                    "number": 135,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "c3859e06-5f23-4302-a71b-04820a899d5f",
                "name": "Travis Kelce",
                "jersey": "87",
                "last_name": "Kelce",
                "first_name": "Travis",
                "abbr_name": "T.Kelce",
                "birth_date": "1989-10-05",
                "weight": 250,
                "height": 77,
                "position": "TE",
                "birth_place": "Cleveland Heights, OH, USA",
                "high_school": "Cleveland Heights (OH)",
                "college": "Cincinnati",
                "college_conf": "American Athletic Conference",
                "rookie_year": 2013,
                "status": "ACT",
                "sr_id": "sr:player:831509",
                "experience": 12,
                "draft": {
                    "year": 2013,
                    "round": 3,
                    "number": 63,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "c7929fb3-5437-42cc-a3c2-10b73ebb1fa0",
                "name": "Leo Chenal",
                "jersey": "54",
                "last_name": "Chenal",
                "first_name": "Leo",
                "abbr_name": "L.Chenal",
                "birth_date": "2000-10-26",
                "weight": 250,
                "height": 75,
                "position": "LB",
                "birth_place": "Grantsburg, WI, USA",
                "high_school": "Grantsburg (WI)",
                "college": "Wisconsin",
                "college_conf": "Big Ten Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1695607",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 3,
                    "number": 103,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "c87aaf5b-e1e9-4d18-b0f1-f328b646031d",
                "name": "Kristian Fulton",
                "last_name": "Fulton",
                "first_name": "Kristian",
                "abbr_name": "K.Fulton",
                "birth_date": "1998-09-03",
                "weight": 197,
                "height": 71,
                "position": "CB",
                "birth_place": "New Orleans, LA, USA",
                "high_school": "Archbishop Rummel (LA)",
                "college": "LSU",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2020,
                "status": "ACT",
                "sr_id": "sr:player:2040061",
                "experience": 4,
                "draft": {
                    "year": 2020,
                    "round": 2,
                    "number": 61,
                    "team": {
                        "id": "d26a1ca5-722d-4274-8f97-c92e49c96315",
                        "name": "Titans",
                        "market": "Tennessee",
                        "alias": "TEN",
                        "sr_id": "sr:competitor:367364"
                    }
                }
            },
            {
                "id": "c97dfcb6-b999-476f-8487-f3848e92df17",
                "name": "Noah Gray",
                "jersey": "83",
                "last_name": "Gray",
                "first_name": "Noah",
                "abbr_name": "N.Gray",
                "birth_date": "1999-04-30",
                "weight": 240,
                "height": 75,
                "position": "TE",
                "birth_place": "Leominster, MA, USA",
                "high_school": "Leominster (MA)",
                "college": "Duke",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2197934",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 5,
                    "number": 162,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "ca5028b1-d96f-4444-9855-46e1661b9d62",
                "name": "Marlon Tuipulotu",
                "last_name": "Tuipulotu",
                "first_name": "Marlon",
                "abbr_name": "M.Tuipulotu",
                "birth_date": "1999-05-31",
                "weight": 307,
                "height": 74,
                "position": "DT",
                "birth_place": "Independence, OR, USA",
                "high_school": "Central (OR)",
                "college": "USC",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:1236182",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 6,
                    "number": 189,
                    "team": {
                        "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                        "name": "Eagles",
                        "market": "Philadelphia",
                        "alias": "PHI",
                        "sr_id": "sr:competitor:4428"
                    }
                }
            },
            {
                "id": "cbd73c09-da07-48b0-a0d6-f248dfa631b6",
                "name": "Rashee Rice",
                "jersey": "4",
                "last_name": "Rice",
                "first_name": "Rashee",
                "abbr_name": "R.Rice",
                "birth_date": "2000-04-22",
                "weight": 204,
                "height": 73,
                "position": "WR",
                "birth_place": "North Richland Hills, TX, USA",
                "high_school": "Richland (TX)",
                "college": "SMU",
                "college_conf": "American Athletic Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1699457",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 2,
                    "number": 55,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "cc4627f1-1af2-4a3d-aa78-c5f905a8a43d",
                "name": "Chamarri Conner",
                "jersey": "27",
                "last_name": "Conner",
                "first_name": "Chamarri",
                "abbr_name": "C.Conner",
                "birth_date": "2000-07-11",
                "weight": 202,
                "height": 72,
                "position": "DB",
                "birth_place": "Jacksonville, FL, USA",
                "high_school": "Trinity Christian Academy (FL)",
                "college": "Virginia Tech",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:1411853",
                "experience": 2,
                "draft": {
                    "year": 2023,
                    "round": 4,
                    "number": 119,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "ccc1bab9-c77d-4d01-857f-9b240b86301a",
                "name": "Ashton Gillotte",
                "last_name": "Gillotte",
                "first_name": "Ashton",
                "abbr_name": "A.Gillotte",
                "birth_date": "2002-10-30",
                "weight": 264,
                "height": 74,
                "position": "DE",
                "birth_place": "Boca Raton, FL, USA",
                "high_school": "Boca Raton (FL)",
                "college": "Louisville",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 3,
                    "number": 66,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "cce91700-ce0c-11ec-8f7c-f5226825ea6a",
                "name": "Justyn Ross",
                "jersey": "82",
                "last_name": "Ross",
                "first_name": "Justyn",
                "abbr_name": "J.Ross",
                "birth_date": "1999-12-15",
                "weight": 210,
                "height": 76,
                "position": "WR",
                "birth_place": "Phenix City, AL, USA",
                "high_school": "Central (AL)",
                "college": "Clemson",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:1410385",
                "experience": 3
            },
            {
                "id": "cfd2da80-07d7-11ef-9eb8-d3c1d804b4f8",
                "name": "Chris Roland-Wallace",
                "jersey": "30",
                "last_name": "Roland-Wallace",
                "first_name": "Chris",
                "abbr_name": "C.Roland-Wallace",
                "birth_date": "2001-11-23",
                "weight": 202,
                "height": 71,
                "position": "CB",
                "birth_place": "Palmdale, CA, USA",
                "high_school": "Williams J. Knight (CA)",
                "college": "USC",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2024,
                "status": "ACT",
                "sr_id": "sr:player:1694287",
                "experience": 0
            },
            {
                "id": "d468dfe5-8ad2-4c8b-b7ba-0962316a2156",
                "name": "Drue Tranquill",
                "jersey": "23",
                "last_name": "Tranquill",
                "first_name": "Drue",
                "abbr_name": "D.Tranquill",
                "birth_date": "1995-08-15",
                "weight": 234,
                "height": 74,
                "position": "LB",
                "birth_place": "Fort Wayne, IN, USA",
                "high_school": "Carroll (IN)",
                "college": "Notre Dame",
                "college_conf": "Independent",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1205822",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 4,
                    "number": 130,
                    "team": {
                        "id": "1f6dcffb-9823-43cd-9ff4-e7a8466749b5",
                        "name": "Chargers",
                        "market": "Los Angeles",
                        "alias": "LAC",
                        "sr_id": "sr:competitor:4429"
                    }
                }
            },
            {
                "id": "d6920940-23ab-11f0-92c8-a5c84f732fb0",
                "name": "Kevin Knowles II",
                "last_name": "Knowles",
                "first_name": "Kevin",
                "abbr_name": "K.Knowles",
                "weight": 190,
                "height": 71,
                "position": "DB",
                "birth_place": "Hollywood, FL, USA",
                "high_school": "McArthur (FL)",
                "college": "Florida State",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 0,
                "status": "ACT",
                "name_suffix": "II",
                "experience": 0
            },
            {
                "id": "dabb52c0-455b-48fe-996b-abf758120623",
                "name": "Gardner Minshew II",
                "last_name": "Minshew",
                "first_name": "Gardner",
                "abbr_name": "G.Minshew",
                "birth_date": "1996-05-16",
                "weight": 225,
                "height": 73,
                "position": "QB",
                "birth_place": "Brandon, MS, USA",
                "high_school": "Brandon (MS)",
                "college": "Washington State",
                "college_conf": "Pacific Twelve Conference",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1222634",
                "name_suffix": "II",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 6,
                    "number": 178,
                    "team": {
                        "id": "f7ddd7fa-0bae-4f90-bc8e-669e4d6cf2de",
                        "name": "Jaguars",
                        "market": "Jacksonville",
                        "alias": "JAC",
                        "sr_id": "sr:competitor:4386"
                    }
                }
            },
            {
                "id": "e4851020-2620-11f0-aaa6-01badd5b0ec1",
                "name": "Melvin Smith Jr.",
                "last_name": "Smith",
                "first_name": "Melvin",
                "abbr_name": "M.Smith",
                "weight": 185,
                "height": 72,
                "position": "DB",
                "birth_place": "Bossier City, LA, USA",
                "college": "Southern Arkansas",
                "college_conf": "Great American Conference",
                "rookie_year": 0,
                "status": "ACT",
                "name_suffix": "Jr.",
                "experience": 0
            },
            {
                "id": "e97a02d1-666b-4df9-bfd4-c375002965c3",
                "name": "Janarius Robinson",
                "last_name": "Robinson",
                "first_name": "Janarius",
                "abbr_name": "J.Robinson",
                "birth_date": "1998-05-04",
                "weight": 260,
                "height": 77,
                "position": "DE",
                "birth_place": "Panama City, FL, USA",
                "high_school": "Bay (FL)",
                "college": "Florida State",
                "college_conf": "Atlantic Coast Conference",
                "rookie_year": 2021,
                "status": "ACT",
                "sr_id": "sr:player:2198094",
                "experience": 4,
                "draft": {
                    "year": 2021,
                    "round": 4,
                    "number": 134,
                    "team": {
                        "id": "33405046-04ee-4058-a950-d606f8c30852",
                        "name": "Vikings",
                        "market": "Minnesota",
                        "alias": "MIN",
                        "sr_id": "sr:competitor:4423"
                    }
                }
            },
            {
                "id": "ef7b5ce8-a929-46be-b9f3-328752c6d125",
                "name": "Chris Jones",
                "jersey": "95",
                "last_name": "Jones",
                "first_name": "Chris",
                "abbr_name": "C.Jones",
                "birth_date": "1994-07-03",
                "weight": 310,
                "height": 78,
                "position": "DT",
                "birth_place": "Houston, MS, USA",
                "high_school": "Houston (MS)",
                "college": "Mississippi State",
                "college_conf": "Southeastern Conference",
                "rookie_year": 2016,
                "status": "ACT",
                "sr_id": "sr:player:987609",
                "experience": 9,
                "draft": {
                    "year": 2016,
                    "round": 2,
                    "number": 37,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "eff1c40e-715c-49c4-93d8-6155322c1205",
                "name": "Charles Omenihu",
                "jersey": "90",
                "last_name": "Omenihu",
                "first_name": "Charles",
                "abbr_name": "C.Omenihu",
                "birth_date": "1997-08-20",
                "weight": 280,
                "height": 77,
                "position": "DE",
                "birth_place": "Rowlett, TX, USA",
                "high_school": "Rowlett (TX)",
                "college": "Texas",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1228620",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 5,
                    "number": 161,
                    "team": {
                        "id": "82d2d380-3834-4938-835f-aec541e5ece7",
                        "name": "Texans",
                        "market": "Houston",
                        "alias": "HOU",
                        "sr_id": "sr:competitor:4324"
                    }
                }
            },
            {
                "id": "f286b160-eba8-11ed-87ba-cb97497fad29",
                "name": "Jason Brownlee",
                "jersey": "89",
                "last_name": "Brownlee",
                "first_name": "Jason",
                "abbr_name": "J.Brownlee",
                "birth_date": "1999-01-30",
                "weight": 202,
                "height": 75,
                "position": "WR",
                "birth_place": "West Point, MS, USA",
                "high_school": "West Point (MS)",
                "college": "Southern Miss",
                "college_conf": "Sun Belt Conference",
                "rookie_year": 2023,
                "status": "ACT",
                "sr_id": "sr:player:2065143",
                "experience": 2
            },
            {
                "id": "f30d7fdd-9d14-4cee-aae7-6ad6ee02935b",
                "name": "Nazeeh Johnson",
                "jersey": "13",
                "last_name": "Johnson",
                "first_name": "Nazeeh",
                "abbr_name": "N.Johnson",
                "birth_date": "1998-07-17",
                "weight": 199,
                "height": 70,
                "position": "SAF",
                "birth_place": "Martinsburg, WV, USA",
                "high_school": "Millbrook (VA)",
                "college": "Marshall",
                "college_conf": "Conference USA",
                "rookie_year": 2022,
                "status": "ACT",
                "sr_id": "sr:player:2343145",
                "experience": 3,
                "draft": {
                    "year": 2022,
                    "round": 7,
                    "number": 259,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "fb38f3cd-8e90-4c41-b10e-0ed37d97c3bc",
                "name": "Jeffrey Bassa",
                "last_name": "Bassa",
                "first_name": "Jeffrey",
                "abbr_name": "J.Bassa",
                "birth_date": "2002-09-20",
                "weight": 232,
                "height": 73,
                "position": "LB",
                "birth_place": "Salt Lake City, UT, USA",
                "high_school": "Kearns (UT)",
                "college": "Oregon",
                "college_conf": "Big Ten Conference",
                "rookie_year": 0,
                "status": "UDF",
                "experience": 0,
                "draft": {
                    "year": 2025,
                    "round": 5,
                    "number": 156,
                    "team": {
                        "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                        "name": "Chiefs",
                        "market": "Kansas City",
                        "alias": "KC",
                        "sr_id": "sr:competitor:4422"
                    }
                }
            },
            {
                "id": "feeee40a-dd63-41a7-89cd-6c95b5456833",
                "name": "Marquise Brown",
                "jersey": "5",
                "last_name": "Brown",
                "first_name": "Hollywood",
                "abbr_name": "M.Brown",
                "preferred_name": "Hollywood",
                "birth_date": "1997-06-04",
                "weight": 180,
                "height": 69,
                "position": "WR",
                "birth_place": "Hollywood, FL, USA",
                "high_school": "Chaminade-Madonna (FL)",
                "college": "Oklahoma",
                "college_conf": "Big Twelve Conference",
                "rookie_year": 2019,
                "status": "ACT",
                "sr_id": "sr:player:1234416",
                "experience": 6,
                "draft": {
                    "year": 2019,
                    "round": 1,
                    "number": 25,
                    "team": {
                        "id": "ebd87119-b331-4469-9ea6-d51fe3ce2f1c",
                        "name": "Ravens",
                        "market": "Baltimore",
                        "alias": "BAL",
                        "sr_id": "sr:competitor:4413"
                    }
                }
            }
        ],
        "_comment": "Generation started @ 2025-05-01 18:06:27 UTC ended @ 2025-05-01 18:06:27 UTC"
    },
    "teamB": {
        "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
    "name": "Eagles",
    "market": "Philadelphia",
    "alias": "PHI",
    "sr_id": "sr:competitor:4428",
    "founded": 1933,
    "owner": "Jeffrey Lurie",
    "general_manager": "Howie Roseman",
    "president": "Don Smolenski",
    "mascot": "Swoop",
    "nicknames": "The Birds",
    "fight_song": "Fly, Eagles Fly",
    "championships_won": 2,
    "championship_seasons": "2017, 2024",
    "conference_titles": 5,
    "division_titles": 13,
    "playoff_appearances": 27,
    "franchise": {
        "id": "8eefc537-0493-4de8-8d64-2c091d3f5887",
        "name": "Eagles",
        "alias": "PHI"
    },
    "venue": {
        "id": "4fa8c29c-6626-464c-8540-314ed7535e1b",
        "name": "Lincoln Financial Field",
        "city": "Philadelphia",
        "state": "PA",
        "country": "USA",
        "zip": "19148",
        "address": "1020 Pattison Avenue",
        "capacity": 69596,
        "surface": "turf",
        "roof_type": "outdoor",
        "sr_id": "sr:venue:1833",
        "location": {
            "lat": "39.900872",
            "lng": "-75.167311"
        }
    },
    "division": {
        "id": "6dab3ca1-b9cb-403f-91dd-b2a3708ab060",
        "name": "NFC East",
        "alias": "NFC_EAST"
    },
    "conference": {
        "id": "b1808e5f-d40b-47c0-8af8-5175c0fdcd26",
        "name": "NFC",
        "alias": "NFC"
    },
    "coaches": [
        {
            "id": "70a145e0-ef0f-11ef-88c1-91fbc459e87c",
            "full_name": "Kevin Patullo",
            "first_name": "Kevin",
            "last_name": "Patullo",
            "position": "Offensive Coordinator"
        },
        {
            "id": "d330d120-e8f8-11ef-bcd3-b58775256daf",
            "full_name": "Michael Clay",
            "first_name": "Michael",
            "last_name": "Clay",
            "position": "Special Teams Coordinator"
        },
        {
            "id": "d81be20b-eab0-4698-b455-07c6ae954432",
            "full_name": "Vic Fangio",
            "first_name": "Vic",
            "last_name": "Fangio",
            "position": "Defensive Coordinator"
        },
        {
            "id": "e488386a-5837-4f69-a8de-49bbf3646517",
            "full_name": "Nick Sirianni",
            "first_name": "Nick",
            "last_name": "Sirianni",
            "position": "Head Coach"
        }
    ],
    "players": [
        {
            "id": "01f15239-cd2c-4bd7-be5d-5ba7eed41331",
            "name": "Moro Ojomo",
            "jersey": "97",
            "last_name": "Ojomo",
            "first_name": "Moro",
            "abbr_name": "M.Ojomo",
            "birth_date": "2001-08-15",
            "weight": 292,
            "height": 75,
            "position": "DT",
            "birth_place": "Lagos,, NGA",
            "high_school": "Katy (TX)",
            "college": "Texas",
            "college_conf": "Big Twelve Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1423099",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 7,
                "number": 249,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "04d384d9-06da-4436-a637-14637705d7b3",
            "name": "Kelee Ringo",
            "jersey": "22",
            "last_name": "Ringo",
            "first_name": "Kelee",
            "abbr_name": "K.Ringo",
            "birth_date": "2002-06-27",
            "weight": 207,
            "height": 74,
            "position": "CB",
            "birth_place": "Tacoma, WA, USA",
            "high_school": "Saguaro (AZ)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:2048815",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 4,
                "number": 105,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "052cdbeb-f758-4110-ac1a-675cd0335db9",
            "name": "Tyrion Davis-Price",
            "jersey": "35",
            "last_name": "Davis-Price",
            "first_name": "Tyrion",
            "abbr_name": "T.Davis-Price",
            "birth_date": "2000-10-23",
            "weight": 219,
            "height": 73,
            "position": "RB",
            "birth_place": "Baton Rouge, LA, USA",
            "high_school": "Southern University Laboratory School (LA)",
            "college": "LSU",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1694045",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 3,
                "number": 93,
                "team": {
                    "id": "f0e724b0-4cbf-495a-be47-013907608da9",
                    "name": "49ers",
                    "market": "San Francisco",
                    "alias": "SF",
                    "sr_id": "sr:competitor:4389"
                }
            }
        },
        {
            "id": "059e5bb7-1842-4558-9aaf-77c352a21216",
            "name": "Jake Elliott",
            "jersey": "4",
            "last_name": "Elliott",
            "first_name": "Jake",
            "abbr_name": "J.Elliott",
            "birth_date": "1995-01-21",
            "weight": 167,
            "height": 69,
            "position": "K",
            "birth_place": "Western Springs, IL, USA",
            "high_school": "Lyons Township (IL)",
            "college": "Memphis",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2017,
            "status": "ACT",
            "sr_id": "sr:player:1130017",
            "experience": 8,
            "draft": {
                "year": 2017,
                "round": 5,
                "number": 153,
                "team": {
                    "id": "ad4ae08f-d808-42d5-a1e6-e9bc4e34d123",
                    "name": "Bengals",
                    "market": "Cincinnati",
                    "alias": "CIN",
                    "sr_id": "sr:competitor:4416"
                }
            }
        },
        {
            "id": "07b963d4-aef7-4874-ba04-f9b1ec1142d3",
            "name": "Bryce Huff",
            "jersey": "0",
            "last_name": "Huff",
            "first_name": "Bryce",
            "abbr_name": "B.Huff",
            "birth_date": "1998-04-17",
            "weight": 255,
            "height": 75,
            "position": "DE",
            "birth_place": "Mobile, AL, USA",
            "high_school": "St. Paul's Episcopal (AL)",
            "college": "Memphis",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:1211942",
            "experience": 5
        },
        {
            "id": "0cb34ce3-42de-42d3-88a4-d242e43b2e34",
            "name": "Andrew Mukuba",
            "last_name": "Mukuba",
            "first_name": "Andrew",
            "abbr_name": "A.Mukuba",
            "birth_date": "2002-12-07",
            "weight": 186,
            "height": 71,
            "position": "SAF",
            "birth_place": "Austin, TX, USA",
            "high_school": "Lyndon (TX)",
            "college": "Texas",
            "college_conf": "Southeastern Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 2,
                "number": 64,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "1159549f-4be1-440b-a950-a6bfab44d5ce",
            "name": "Jeremiah Trotter Jr.",
            "jersey": "54",
            "last_name": "Trotter",
            "first_name": "Jeremiah",
            "abbr_name": "J.Trotter",
            "birth_date": "2002-12-24",
            "weight": 225,
            "height": 72,
            "position": "LB",
            "birth_place": "Hainesport, NJ, USA",
            "high_school": "St. Joseph's (PA)",
            "college": "Clemson",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:2158318",
            "name_suffix": "Jr.",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 5,
                "number": 155,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "119e79fa-0453-4253-9b3d-9a8ef03a48ec",
            "name": "Nakobe Dean",
            "jersey": "17",
            "last_name": "Dean",
            "first_name": "Nakobe",
            "abbr_name": "N.Dean",
            "birth_date": "2000-12-13",
            "weight": 231,
            "height": 71,
            "position": "LB",
            "birth_place": "Horn Lake, MS, USA",
            "high_school": "Horn Lake (MS)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1693753",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 3,
                "number": 83,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "1377e940-eb75-11ed-aecd-85bc826ed43e",
            "name": "Ben VanSumeren",
            "jersey": "57",
            "last_name": "VanSumeren",
            "first_name": "Ben",
            "abbr_name": "B.VanSumeren",
            "birth_date": "2000-05-05",
            "weight": 231,
            "height": 74,
            "position": "FB",
            "birth_place": "Bay City, MI, USA",
            "high_school": "Garber (MI)",
            "college": "Michigan State",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1436608",
            "experience": 2
        },
        {
            "id": "151a3910-c966-11ec-9af6-61153bad5574",
            "name": "Tristin McCollum",
            "jersey": "36",
            "last_name": "McCollum",
            "first_name": "Tristin",
            "abbr_name": "T.McCollum",
            "birth_date": "1999-05-03",
            "weight": 195,
            "height": 75,
            "position": "SAF",
            "birth_place": "Galveston, TX, USA",
            "high_school": "Ball (TX)",
            "college": "Sam Houston",
            "college_conf": "Southland Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1258924",
            "experience": 1
        },
        {
            "id": "1693934a-76eb-4cf9-a5cf-e0bb6df92ace",
            "name": "Patrick Johnson",
            "last_name": "Johnson",
            "first_name": "Patrick",
            "abbr_name": "P.Johnson",
            "birth_date": "1998-01-10",
            "weight": 248,
            "height": 74,
            "position": "OLB",
            "birth_place": "Chattanooga, TN, USA",
            "high_school": "Notre Dame (TN)",
            "college": "Tulane",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:1258162",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 7,
                "number": 234,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "193ab2af-e24e-4abc-aad7-196328445984",
            "name": "Ty Robinson",
            "last_name": "Robinson",
            "first_name": "Ty",
            "abbr_name": "T.Robinson",
            "birth_date": "2001-05-03",
            "weight": 288,
            "height": 77,
            "position": "DT",
            "birth_place": "Gilbert, AZ, USA",
            "high_school": "Higley (AZ)",
            "college": "Nebraska",
            "college_conf": "Big Ten Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 4,
                "number": 111,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "1b29e8b0-263c-11f0-a83a-5dc5f977bd5d",
            "name": "Taylor Morin",
            "last_name": "Morin",
            "first_name": "Taylor",
            "abbr_name": "T.Morin",
            "weight": 185,
            "height": 71,
            "position": "WR",
            "birth_place": "Centreville, VA, USA",
            "high_school": "Westfield (VA)",
            "college": "Wake Forest",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "1c443cd8-b9ad-4676-9a8e-8cee52b07637",
            "name": "Jalen Carter",
            "jersey": "98",
            "last_name": "Carter",
            "first_name": "Jalen",
            "abbr_name": "J.Carter",
            "birth_date": "2001-04-04",
            "weight": 314,
            "height": 75,
            "position": "DT",
            "birth_place": "Apopka, FL, USA",
            "high_school": "Apopka (FL)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:2007055",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 1,
                "number": 9,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "2177026c-2b34-4b88-bc88-50d7c9962064",
            "name": "Parry Nickerson",
            "jersey": "30",
            "last_name": "Nickerson",
            "first_name": "Parry",
            "abbr_name": "P.Nickerson",
            "birth_date": "1994-10-11",
            "weight": 182,
            "height": 70,
            "position": "CB",
            "birth_place": "New Orleans, LA, USA",
            "high_school": "West Jefferson (LA)",
            "college": "Tulane",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2018,
            "status": "ACT",
            "sr_id": "sr:player:1474668",
            "experience": 5,
            "draft": {
                "year": 2018,
                "round": 6,
                "number": 179,
                "team": {
                    "id": "5fee86ae-74ab-4bdd-8416-42a9dd9964f3",
                    "name": "Jets",
                    "market": "New York",
                    "alias": "NYJ",
                    "sr_id": "sr:competitor:4427"
                }
            }
        },
        {
            "id": "2eb34969-3de2-454f-a822-bf1908dabcaa",
            "name": "Tariq Castro-Fields",
            "jersey": "46",
            "last_name": "Castro-Fields",
            "first_name": "Tariq",
            "abbr_name": "T.Castro-Fields",
            "birth_date": "1999-01-14",
            "weight": 197,
            "height": 73,
            "position": "DB",
            "birth_place": "Upper Marlboro, MD, USA",
            "high_school": "Riverdale Baptist (MD)",
            "college": "Penn State",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1270954",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 6,
                "number": 221,
                "team": {
                    "id": "f0e724b0-4cbf-495a-be47-013907608da9",
                    "name": "49ers",
                    "market": "San Francisco",
                    "alias": "SF",
                    "sr_id": "sr:competitor:4389"
                }
            }
        },
        {
            "id": "3555d07e-57ae-43de-97d5-b1b5bf055f17",
            "name": "DeVonta Smith",
            "jersey": "6",
            "last_name": "Smith",
            "first_name": "DeVonta",
            "abbr_name": "D.Smith",
            "birth_date": "1998-11-14",
            "weight": 170,
            "height": 72,
            "position": "WR",
            "birth_place": "Amite City, LA, USA",
            "high_school": "Amite (LA)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:1831406",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 1,
                "number": 10,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "3557e290-2449-11f0-9b47-b3e02d0eb26f",
            "name": "Montrell Johnson Jr.",
            "last_name": "Johnson",
            "first_name": "Montrell",
            "abbr_name": "M.Johnson",
            "birth_date": "2002-10-13",
            "weight": 216,
            "height": 71,
            "position": "RB",
            "birth_place": "New Orleans, LA, USA",
            "high_school": "De La Salle (LA)",
            "college": "Florida",
            "college_conf": "Southeastern Conference",
            "rookie_year": 0,
            "status": "ACT",
            "name_suffix": "Jr.",
            "experience": 0
        },
        {
            "id": "3763a2ec-ee98-4cf4-9aa7-ee626057c56f",
            "name": "Cameron Latu",
            "last_name": "Latu",
            "first_name": "Cameron",
            "abbr_name": "C.Latu",
            "birth_date": "2000-02-24",
            "weight": 244,
            "height": 77,
            "position": "TE",
            "birth_place": "Chisholm, MN, USA",
            "high_school": "Olympus (UT)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1415235",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 3,
                "number": 101,
                "team": {
                    "id": "f0e724b0-4cbf-495a-be47-013907608da9",
                    "name": "49ers",
                    "market": "San Francisco",
                    "alias": "SF",
                    "sr_id": "sr:competitor:4389"
                }
            }
        },
        {
            "id": "3b1c43d0-8442-4103-8bc2-952bedc44639",
            "name": "Drew Kendall",
            "last_name": "Kendall",
            "first_name": "Drew",
            "abbr_name": "D.Kendall",
            "birth_date": "2001-11-27",
            "weight": 308,
            "height": 76,
            "position": "OL",
            "birth_place": "Norwell, MA, USA",
            "high_school": "Noble and Greenough (MA)",
            "college": "Boston College",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 5,
                "number": 168,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "3edf64e6-603b-4437-a3be-53fe030c6f56",
            "name": "Lane Johnson",
            "jersey": "65",
            "last_name": "Johnson",
            "first_name": "Lane",
            "abbr_name": "L.Johnson",
            "preferred_name": "Lane",
            "birth_date": "1990-05-08",
            "weight": 325,
            "height": 78,
            "position": "T",
            "birth_place": "Groveton, TX, USA",
            "high_school": "Groveton (TX)",
            "college": "Oklahoma",
            "college_conf": "Big Twelve Conference",
            "rookie_year": 2013,
            "status": "ACT",
            "sr_id": "sr:player:827401",
            "experience": 12,
            "draft": {
                "year": 2013,
                "round": 1,
                "number": 4,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "41778790-072d-11ef-8f9f-dd59e5c066c4",
            "name": "Gabe Hall",
            "jersey": "96",
            "last_name": "Hall",
            "first_name": "Gabe",
            "abbr_name": "G.Hall",
            "birth_date": "2001-01-12",
            "weight": 295,
            "height": 78,
            "position": "DT",
            "birth_place": "Waller, TX, USA",
            "high_school": "Waller (TX)",
            "college": "Baylor",
            "college_conf": "Big Twelve Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1800344",
            "experience": 0
        },
        {
            "id": "43a74ae6-ddb7-405e-8ccd-69d14da6c374",
            "name": "Charley Hughlett",
            "jersey": "47",
            "last_name": "Hughlett",
            "first_name": "Charley",
            "abbr_name": "C.Hughlett",
            "birth_date": "1990-05-16",
            "weight": 251,
            "height": 76,
            "position": "LS",
            "birth_place": "Tampa, FL, USA",
            "high_school": "Hillsborough (FL)",
            "college": "UCF",
            "college_conf": "Conference USA",
            "rookie_year": 2012,
            "status": "ACT",
            "sr_id": "sr:player:831147",
            "experience": 10
        },
        {
            "id": "44f764e5-d32e-4cc9-a2d1-bd0e77fc8654",
            "name": "Myles Hinton",
            "last_name": "Hinton",
            "first_name": "Myles",
            "abbr_name": "M.Hinton",
            "birth_date": "2022-01-09",
            "weight": 323,
            "height": 78,
            "position": "OT",
            "birth_place": "Johns Creek, GA, USA",
            "high_school": "Greater Atlanta (GA)",
            "college": "Michigan",
            "college_conf": "Big Ten Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 6,
                "number": 191,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "451c7689-4fc2-410a-a33f-22dfa2ab37d4",
            "name": "Kyle McCord",
            "last_name": "McCord",
            "first_name": "Kyle",
            "abbr_name": "K.McCord",
            "birth_date": "2002-09-19",
            "weight": 218,
            "height": 75,
            "position": "QB",
            "birth_place": "Mount Laurel, NJ, USA",
            "high_school": "St. Joseph's (PA)",
            "college": "Syracuse",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 6,
                "number": 181,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "4c01d331-f294-4836-bbfc-3369829d66c8",
            "name": "Jordan Mailata",
            "jersey": "68",
            "last_name": "Mailata",
            "first_name": "Jordan",
            "abbr_name": "J.Mailata",
            "birth_date": "1997-03-31",
            "weight": 365,
            "height": 80,
            "position": "T",
            "birth_place": "Sydney,, AUS",
            "high_school": "Condell Park (AUS)",
            "rookie_year": 2018,
            "status": "ACT",
            "sr_id": "sr:player:1474864",
            "experience": 7,
            "draft": {
                "year": 2018,
                "round": 7,
                "number": 233,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "4d4fe2b0-2450-11f0-9549-f3c45db86236",
            "name": "Lance Dixon",
            "last_name": "Dixon",
            "first_name": "Lance",
            "abbr_name": "L.Dixon",
            "weight": 233,
            "height": 74,
            "position": "LB",
            "birth_place": "Oak Park, MI, USA",
            "high_school": "West Bloomfield (MI)",
            "college": "Toledo",
            "college_conf": "Mid-American Conference",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "513ce4c0-0581-11ef-87fc-5d57216b511b",
            "name": "Dallas Gant",
            "jersey": "52",
            "last_name": "Gant",
            "first_name": "Dallas",
            "abbr_name": "D.Gant",
            "birth_date": "2000-05-16",
            "weight": 224,
            "height": 74,
            "position": "LB",
            "birth_place": "Toledo, OH, USA",
            "high_school": "St. John's Jesuit (OH)",
            "college": "Toledo",
            "college_conf": "Mid-American Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1436904",
            "experience": 0
        },
        {
            "id": "51e0ab4b-c18b-4fef-99cb-07faba2f9cb1",
            "name": "Trevor Keegan",
            "jersey": "79",
            "last_name": "Keegan",
            "first_name": "Trevor",
            "abbr_name": "T.Keegan",
            "birth_date": "2000-08-30",
            "weight": 306,
            "height": 77,
            "position": "G",
            "birth_place": "Crystal Lake, IL, USA",
            "high_school": "Crystal Lake South (IL)",
            "college": "Michigan",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1694623",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 5,
                "number": 172,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "542de5c0-263d-11f0-961b-296ef24a1ae9",
            "name": "ShunDerrick Powell",
            "last_name": "Powell",
            "first_name": "ShunDerrick",
            "abbr_name": "S.Powell",
            "weight": 180,
            "height": 69,
            "position": "RB",
            "birth_place": "Hoxie, AR, USA",
            "high_school": "Hoxie (AR)",
            "college": "Central Arkansas",
            "college_conf": "United Athletic Conference",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "5605cc4e-a0ed-4525-9dc1-5d439544793a",
            "name": "Thomas Booker IV",
            "jersey": "59",
            "last_name": "Booker",
            "first_name": "Thomas",
            "abbr_name": "T.Booker",
            "birth_date": "1999-11-11",
            "weight": 301,
            "height": 75,
            "position": "DT",
            "birth_place": "Ellicott City, MD, USA",
            "high_school": "Gilman (MD)",
            "college": "Stanford",
            "college_conf": "Pacific Twelve Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1439006",
            "name_suffix": "IV",
            "experience": 2,
            "draft": {
                "year": 2022,
                "round": 5,
                "number": 150,
                "team": {
                    "id": "82d2d380-3834-4938-835f-aec541e5ece7",
                    "name": "Texans",
                    "market": "Houston",
                    "alias": "HOU",
                    "sr_id": "sr:competitor:4324"
                }
            }
        },
        {
            "id": "5c3b05f0-09b4-11ef-93d3-a14a9d0aadbf",
            "name": "Laekin Vakalahi",
            "jersey": "67",
            "last_name": "Vakalahi",
            "first_name": "Laekin",
            "abbr_name": "L.Vakalahi",
            "birth_date": "2003-01-28",
            "weight": 320,
            "height": 77,
            "position": "OT",
            "birth_place": "Brisbane,, AUS",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:2799905",
            "experience": 0
        },
        {
            "id": "626a1dd0-ebab-11ed-bb4c-e536974648f2",
            "name": "E.J. Jenkins",
            "jersey": "84",
            "last_name": "Jenkins",
            "first_name": "E.J.",
            "abbr_name": "E.Jenkins",
            "birth_date": "1998-11-03",
            "weight": 245,
            "height": 78,
            "position": "TE",
            "birth_place": "Fredricksburg, VA, USA",
            "high_school": "Chancellor (VA)",
            "college": "Georgia Tech",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1266504",
            "experience": 1
        },
        {
            "id": "63ddbf22-f7f5-4552-8617-142b2417ee64",
            "name": "Antwaun Powell-Ryland",
            "last_name": "Powell-Ryland",
            "first_name": "Antwaun",
            "abbr_name": "A.Powell-Ryland",
            "birth_date": "2002-02-23",
            "weight": 258,
            "height": 74,
            "position": "OLB",
            "birth_place": "Portsmouth, VA, USA",
            "high_school": "Clovis (NM)",
            "college": "Virginia Tech",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 6,
                "number": 209,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "6497034a-2855-4296-9781-ffab2819df14",
            "name": "Lewis Cine",
            "jersey": "38",
            "last_name": "Cine",
            "first_name": "Lewis",
            "abbr_name": "L.Cine",
            "birth_date": "1999-10-05",
            "weight": 199,
            "height": 74,
            "position": "SAF",
            "birth_place": "Cedar Hill, TX, USA",
            "high_school": "Everett (MA)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1693755",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 1,
                "number": 32,
                "team": {
                    "id": "33405046-04ee-4058-a950-d606f8c30852",
                    "name": "Vikings",
                    "market": "Minnesota",
                    "alias": "MIN",
                    "sr_id": "sr:competitor:4423"
                }
            }
        },
        {
            "id": "64bd0f02-6a5d-407e-98f1-fd02048ea21d",
            "name": "Jalen Hurts",
            "jersey": "1",
            "last_name": "Hurts",
            "first_name": "Jalen",
            "abbr_name": "J.Hurts",
            "birth_date": "1998-08-07",
            "weight": 223,
            "height": 73,
            "position": "QB",
            "birth_place": "Houston, TX, USA",
            "high_school": "Channelview (TX)",
            "college": "Oklahoma",
            "college_conf": "Big Twelve Conference",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:2040065",
            "experience": 5,
            "draft": {
                "year": 2020,
                "round": 2,
                "number": 53,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "650c8ab6-958d-47b6-bdc0-62fe852a4f10",
            "name": "Darian Kinnard",
            "jersey": "72",
            "last_name": "Kinnard",
            "first_name": "Darian",
            "abbr_name": "D.Kinnard",
            "birth_date": "1999-12-29",
            "weight": 322,
            "height": 77,
            "position": "G",
            "birth_place": "Youngstown, OH, USA",
            "high_school": "Saint Ignatius (OH)",
            "college": "Kentucky",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1415999",
            "experience": 2,
            "draft": {
                "year": 2022,
                "round": 5,
                "number": 145,
                "team": {
                    "id": "6680d28d-d4d2-49f6-aace-5292d3ec02c2",
                    "name": "Chiefs",
                    "market": "Kansas City",
                    "alias": "KC",
                    "sr_id": "sr:competitor:4422"
                }
            }
        },
        {
            "id": "6528c7dc-2a02-4577-9246-b590be05eeeb",
            "name": "Jordan Davis",
            "jersey": "90",
            "last_name": "Davis",
            "first_name": "Jordan",
            "abbr_name": "J.Davis",
            "birth_date": "2000-01-12",
            "weight": 336,
            "height": 78,
            "position": "DT",
            "birth_place": "Charlotte, NC, USA",
            "high_school": "Mallard Creek (NC)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1415219",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 1,
                "number": 13,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "69388223-d1e7-46c3-9106-e10edb7073e9",
            "name": "Terrace Marshall",
            "last_name": "Marshall",
            "first_name": "Terrace",
            "abbr_name": "T.Marshall",
            "birth_date": "2000-06-09",
            "weight": 200,
            "height": 74,
            "position": "WR",
            "birth_place": "Bossier City, LA, USA",
            "high_school": "Parkway (LA)",
            "college": "LSU",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:2198140",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 2,
                "number": 59,
                "team": {
                    "id": "f14bf5cc-9a82-4a38-bc15-d39f75ed5314",
                    "name": "Panthers",
                    "market": "Carolina",
                    "alias": "CAR",
                    "sr_id": "sr:competitor:4415"
                }
            }
        },
        {
            "id": "6a904c64-5425-4f6d-b35a-1b72eaa256c6",
            "name": "Landon Dickerson",
            "jersey": "69",
            "last_name": "Dickerson",
            "first_name": "Landon",
            "abbr_name": "L.Dickerson",
            "birth_date": "1998-09-30",
            "weight": 332,
            "height": 78,
            "position": "G",
            "birth_place": "Hickory, NC, USA",
            "high_school": "South Caldwell (NC)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:2197728",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 2,
                "number": 37,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "6b2ee61f-463f-478a-9bfa-e43c8e9b0c2e",
            "name": "Avery Williams",
            "jersey": "18",
            "last_name": "Williams",
            "first_name": "Avery",
            "abbr_name": "A.Williams",
            "birth_date": "1998-07-15",
            "weight": 200,
            "height": 69,
            "position": "RB",
            "birth_place": "Pasadena, CA, USA",
            "high_school": "JSerra Catholic (CA)",
            "college": "Boise State",
            "college_conf": "Mountain West Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:2198546",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 5,
                "number": 183,
                "team": {
                    "id": "e6aa13a4-0055-48a9-bc41-be28dc106929",
                    "name": "Falcons",
                    "market": "Atlanta",
                    "alias": "ATL",
                    "sr_id": "sr:competitor:4393"
                }
            }
        },
        {
            "id": "6b5dd4bc-9959-4e0f-94f6-74e2577a022a",
            "name": "Nick Muse",
            "jersey": "87",
            "last_name": "Muse",
            "first_name": "Nick",
            "abbr_name": "N.Muse",
            "birth_date": "1998-11-25",
            "weight": 252,
            "height": 77,
            "position": "TE",
            "birth_place": "Belmont, NC, USA",
            "high_school": "South Point (NC)",
            "college": "South Carolina",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1245902",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 7,
                "number": 227,
                "team": {
                    "id": "33405046-04ee-4058-a950-d606f8c30852",
                    "name": "Vikings",
                    "market": "Minnesota",
                    "alias": "MIN",
                    "sr_id": "sr:competitor:4423"
                }
            }
        },
        {
            "id": "6db40c6e-7d09-486e-b80d-1d8008547250",
            "name": "Adoree' Jackson",
            "last_name": "Jackson",
            "first_name": "Adoree'",
            "abbr_name": "A.Jackson",
            "birth_date": "1995-09-18",
            "weight": 185,
            "height": 71,
            "position": "CB",
            "birth_place": "Belleville, IL, USA",
            "high_school": "Junipero Serra (CA)",
            "college": "USC",
            "college_conf": "Pacific Twelve Conference",
            "rookie_year": 2017,
            "status": "ACT",
            "sr_id": "sr:player:1129503",
            "experience": 8,
            "draft": {
                "year": 2017,
                "round": 1,
                "number": 18,
                "team": {
                    "id": "d26a1ca5-722d-4274-8f97-c92e49c96315",
                    "name": "Titans",
                    "market": "Tennessee",
                    "alias": "TEN",
                    "sr_id": "sr:competitor:367364"
                }
            }
        },
        {
            "id": "719a7e8e-8286-453e-8aee-d2487c45e53f",
            "name": "Zack Baun",
            "jersey": "53",
            "last_name": "Baun",
            "first_name": "Zack",
            "abbr_name": "Z.Baun",
            "birth_date": "1996-12-30",
            "weight": 225,
            "height": 75,
            "position": "LB",
            "birth_place": "Brown Deer, WI, USA",
            "high_school": "Brown Deer (WI)",
            "college": "Wisconsin",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:2039979",
            "experience": 5,
            "draft": {
                "year": 2020,
                "round": 3,
                "number": 74,
                "team": {
                    "id": "0d855753-ea21-4953-89f9-0e20aff9eb73",
                    "name": "Saints",
                    "market": "New Orleans",
                    "alias": "NO",
                    "sr_id": "sr:competitor:4425"
                }
            }
        },
        {
            "id": "72e4032d-8d7b-484f-95a2-a73fbb2c67f4",
            "name": "Lew Nichols",
            "last_name": "Nichols",
            "first_name": "Lew",
            "abbr_name": "L.Nichols",
            "birth_date": "2001-08-16",
            "weight": 220,
            "height": 70,
            "position": "RB",
            "birth_place": "Detroit, MI, USA",
            "high_school": "Cass Tech (MI)",
            "college": "Central Michigan",
            "college_conf": "Mid-American Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1708609",
            "experience": 1,
            "draft": {
                "year": 2023,
                "round": 7,
                "number": 235,
                "team": {
                    "id": "a20471b4-a8d9-40c7-95ad-90cc30e46932",
                    "name": "Packers",
                    "market": "Green Bay",
                    "alias": "GB",
                    "sr_id": "sr:competitor:4420"
                }
            }
        },
        {
            "id": "782c4f21-74b8-4fb1-b9a9-f908e4de81b1",
            "name": "Matt Pryor",
            "last_name": "Pryor",
            "first_name": "Matt",
            "abbr_name": "M.Pryor",
            "birth_date": "1994-12-16",
            "weight": 332,
            "height": 79,
            "position": "OL",
            "birth_place": "Long Beach, CA, USA",
            "high_school": "Lakewood (CA)",
            "college": "TCU",
            "college_conf": "Big Twelve Conference",
            "rookie_year": 2018,
            "status": "ACT",
            "sr_id": "sr:player:1220234",
            "experience": 7,
            "draft": {
                "year": 2018,
                "round": 6,
                "number": 206,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "78af6ab8-1003-423d-b29b-111d8f4d45ad",
            "name": "Azeez Ojulari",
            "last_name": "Ojulari",
            "first_name": "Azeez",
            "abbr_name": "A.Ojulari",
            "birth_date": "2000-06-16",
            "weight": 240,
            "height": 75,
            "position": "OLB",
            "birth_place": "Austell, GA, USA",
            "high_school": "Marietta (GA)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:2197868",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 2,
                "number": 50,
                "team": {
                    "id": "04aa1c9d-66da-489d-b16a-1dee3f2eec4d",
                    "name": "Giants",
                    "market": "New York",
                    "alias": "NYG",
                    "sr_id": "sr:competitor:4426"
                }
            }
        },
        {
            "id": "796e223d-e8d5-42ab-afb4-557fa6183357",
            "name": "Will Shipley",
            "jersey": "28",
            "last_name": "Shipley",
            "first_name": "Will",
            "abbr_name": "W.Shipley",
            "birth_date": "2002-08-29",
            "weight": 209,
            "height": 71,
            "position": "RB",
            "birth_place": "Weddington, NC, USA",
            "high_school": "Weddington (NC)",
            "college": "Clemson",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:2158324",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 4,
                "number": 127,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "7ec60efe-5dd3-43c3-b76f-f0d00589fdc3",
            "name": "Danny Gray",
            "jersey": "41",
            "last_name": "Gray",
            "first_name": "Danny",
            "abbr_name": "D.Gray",
            "birth_date": "1999-04-01",
            "weight": 200,
            "height": 72,
            "position": "WR",
            "birth_place": "Dallas, TX, USA",
            "high_school": "James Madison (TX)",
            "college": "SMU",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1415877",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 3,
                "number": 105,
                "team": {
                    "id": "f0e724b0-4cbf-495a-be47-013907608da9",
                    "name": "49ers",
                    "market": "San Francisco",
                    "alias": "SF",
                    "sr_id": "sr:competitor:4389"
                }
            }
        },
        {
            "id": "801201a0-2451-11f0-9f65-ef3f4ca7be78",
            "name": "BJ Mayes",
            "last_name": "Mayes",
            "first_name": "BJ",
            "abbr_name": "B.Mayes",
            "weight": 195,
            "height": 73,
            "position": "CB",
            "birth_place": "Houston, TX, USA",
            "high_school": "Houston Heights (TX)",
            "college": "Texas A&M",
            "college_conf": "Southeastern Conference\t",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "83a78cfb-5e71-4131-b706-3661bb6396e1",
            "name": "Ainias Smith",
            "jersey": "82",
            "last_name": "Smith",
            "first_name": "Ainias",
            "abbr_name": "A.Smith",
            "birth_date": "2001-05-31",
            "weight": 176,
            "height": 69,
            "position": "WR",
            "birth_place": "Missouri City, TX, USA",
            "high_school": "Dulles (TX)",
            "college": "Texas A&M",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1708473",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 5,
                "number": 152,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "85eaaf9f-59cf-4150-943c-c1abdaa78eb1",
            "name": "Braden Mann",
            "jersey": "10",
            "last_name": "Mann",
            "first_name": "Braden",
            "abbr_name": "B.Mann",
            "birth_date": "1997-11-24",
            "weight": 198,
            "height": 71,
            "position": "P",
            "birth_place": "Houston, TX, USA",
            "high_school": "Cy-Fair (TX)",
            "college": "Texas A&M",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:2040617",
            "experience": 5,
            "draft": {
                "year": 2020,
                "round": 6,
                "number": 191,
                "team": {
                    "id": "5fee86ae-74ab-4bdd-8416-42a9dd9964f3",
                    "name": "Jets",
                    "market": "New York",
                    "alias": "NYJ",
                    "sr_id": "sr:competitor:4427"
                }
            }
        },
        {
            "id": "8738c2cc-4ac6-4288-922d-ce4590d9af42",
            "name": "Joshua Uche",
            "last_name": "Uche",
            "first_name": "Joshua",
            "abbr_name": "J.Uche",
            "birth_date": "1998-09-18",
            "weight": 226,
            "height": 75,
            "position": "OLB",
            "birth_place": "Miami, FL, USA",
            "high_school": "Columbus (FL)",
            "college": "Michigan",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:2039965",
            "experience": 5,
            "draft": {
                "year": 2020,
                "round": 2,
                "number": 60,
                "team": {
                    "id": "97354895-8c77-4fd4-a860-32e62ea7382a",
                    "name": "Patriots",
                    "market": "New England",
                    "alias": "NE",
                    "sr_id": "sr:competitor:4424"
                }
            }
        },
        {
            "id": "88ed591a-e082-4539-8fb5-7932a0dc9f9e",
            "name": "Kenyon Green",
            "last_name": "Green",
            "first_name": "Kenyon",
            "abbr_name": "K.Green",
            "birth_date": "2001-03-15",
            "weight": 323,
            "height": 76,
            "position": "G",
            "birth_place": "Humble, TX, USA",
            "high_school": "Atascocita (TX)",
            "college": "Texas A&M",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1695991",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 1,
                "number": 15,
                "team": {
                    "id": "82d2d380-3834-4938-835f-aec541e5ece7",
                    "name": "Texans",
                    "market": "Houston",
                    "alias": "HOU",
                    "sr_id": "sr:competitor:4324"
                }
            }
        },
        {
            "id": "8b7504e3-c5ce-4e91-90d1-2bd8e975c5ed",
            "name": "Cameron Williams",
            "last_name": "Williams",
            "first_name": "Cameron",
            "abbr_name": "C.Williams",
            "birth_date": "2003-10-16",
            "weight": 317,
            "height": 77,
            "position": "OT",
            "birth_place": "Duncanville, TX, USA",
            "high_school": "Duncanville (TX)",
            "college": "Texas",
            "college_conf": "Southeastern Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 6,
                "number": 207,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "93147c90-09c8-471d-a6b2-0b9d19739ba1",
            "name": "Tanner McKee",
            "jersey": "16",
            "last_name": "McKee",
            "first_name": "Tanner",
            "abbr_name": "T.McKee",
            "birth_date": "2000-04-27",
            "weight": 231,
            "height": 78,
            "position": "QB",
            "birth_place": "Corona, CA, USA",
            "high_school": "Centennial (CA)",
            "college": "Stanford",
            "college_conf": "Pacific Twelve Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1438930",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 6,
                "number": 188,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "93c05980-0658-11ef-909c-d744eed76b9a",
            "name": "A.J. Woods",
            "jersey": "39",
            "last_name": "Woods",
            "first_name": "A.J.",
            "abbr_name": "A.Woods",
            "birth_date": "2001-03-28",
            "weight": 186,
            "height": 69,
            "position": "CB",
            "birth_place": "Germantown, MD, USA",
            "high_school": "Northwest (MD)",
            "college": "Pittsburgh",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1692053",
            "experience": 0
        },
        {
            "id": "93e6a6eb-a91e-4705-b5de-faa10f741913",
            "name": "Quinyon Mitchell",
            "jersey": "27",
            "last_name": "Mitchell",
            "first_name": "Quinyon",
            "abbr_name": "Q.Mitchell",
            "birth_date": "2001-07-18",
            "weight": 193,
            "height": 72,
            "position": "CB",
            "birth_place": "Williston, FL, USA",
            "high_school": "Williston (FL)",
            "college": "Toledo",
            "college_conf": "Mid-American Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:2003871",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 1,
                "number": 22,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "93fb0a30-eb74-11ed-aecd-85bc826ed43e",
            "name": "Eli Ricks",
            "jersey": "23",
            "last_name": "Ricks",
            "first_name": "Eli",
            "abbr_name": "E.Ricks",
            "birth_date": "2001-09-26",
            "weight": 188,
            "height": 74,
            "position": "CB",
            "birth_place": "Rancho Cucamonga, CA, USA",
            "high_school": "IMG Academy (FL)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:2007001",
            "experience": 2
        },
        {
            "id": "980ab578-c9d3-4ba5-912d-b723e5b6a0fb",
            "name": "Smael Mondon Jr.",
            "last_name": "Mondon",
            "first_name": "Smael",
            "abbr_name": "S.Mondon",
            "birth_date": "2003-02-13",
            "weight": 224,
            "height": 74,
            "position": "LB",
            "birth_place": "Dallas, GA, USA",
            "high_school": "Paulding County (GA)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 0,
            "status": "UDF",
            "name_suffix": "Jr.",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 5,
                "number": 161,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "9811b753-347c-467a-b3cb-85937e71e2b9",
            "name": "Saquon Barkley",
            "jersey": "26",
            "last_name": "Barkley",
            "first_name": "Saquon",
            "abbr_name": "S.Barkley",
            "birth_date": "1997-02-09",
            "weight": 233,
            "height": 72,
            "position": "RB",
            "birth_place": "Bronx, NY, USA",
            "high_school": "Whitehall (PA)",
            "college": "Penn State",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2018,
            "status": "ACT",
            "sr_id": "sr:player:1473460",
            "experience": 7,
            "draft": {
                "year": 2018,
                "round": 1,
                "number": 2,
                "team": {
                    "id": "04aa1c9d-66da-489d-b16a-1dee3f2eec4d",
                    "name": "Giants",
                    "market": "New York",
                    "alias": "NYG",
                    "sr_id": "sr:competitor:4426"
                }
            }
        },
        {
            "id": "9d76b520-072d-11ef-a877-6b032c0eabad",
            "name": "Andre' Sam",
            "jersey": "31",
            "last_name": "Sam",
            "first_name": "Andre'",
            "abbr_name": "A.Sam",
            "birth_date": "1999-02-09",
            "weight": 194,
            "height": 70,
            "position": "SAF",
            "birth_place": "Iowa, LA, USA",
            "high_school": "Iowa (LA)",
            "college": "LSU",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1260504",
            "experience": 0
        },
        {
            "id": "a4d061b3-d212-4534-88de-c996f64e5754",
            "name": "Cam Jurgens",
            "jersey": "51",
            "last_name": "Jurgens",
            "first_name": "Cam",
            "abbr_name": "C.Jurgens",
            "birth_date": "1999-08-21",
            "weight": 303,
            "height": 75,
            "position": "OL",
            "birth_place": "Beatrice, NE, USA",
            "high_school": "Beatrice (NE)",
            "college": "Nebraska",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1436632",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 2,
                "number": 51,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "a87f6156-c028-4634-84a8-e3388d6dff2b",
            "name": "Kendall Lamm",
            "last_name": "Lamm",
            "first_name": "Kendall",
            "abbr_name": "K.Lamm",
            "birth_date": "1992-06-05",
            "weight": 305,
            "height": 78,
            "position": "T",
            "birth_place": "Charlotte, NC, USA",
            "high_school": "Butler (NC)",
            "college": "Appalachian State",
            "college_conf": "Sun Belt Conference",
            "rookie_year": 2015,
            "status": "ACT",
            "sr_id": "sr:player:835487",
            "experience": 9
        },
        {
            "id": "a9e580f2-1fbe-46fb-887c-c84089b507e4",
            "name": "A.J. Brown",
            "jersey": "11",
            "last_name": "Brown",
            "first_name": "A.J.",
            "abbr_name": "A.Brown",
            "birth_date": "1997-06-30",
            "weight": 226,
            "height": 73,
            "position": "WR",
            "birth_place": "Starkville, MS, USA",
            "high_school": "Starkville (MS)",
            "college": "Ole Miss",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2019,
            "status": "ACT",
            "sr_id": "sr:player:1224438",
            "experience": 6,
            "draft": {
                "year": 2019,
                "round": 2,
                "number": 51,
                "team": {
                    "id": "d26a1ca5-722d-4274-8f97-c92e49c96315",
                    "name": "Titans",
                    "market": "Tennessee",
                    "alias": "TEN",
                    "sr_id": "sr:competitor:367364"
                }
            }
        },
        {
            "id": "b67359a0-244d-11f0-b689-9f364bcf2534",
            "name": "Hollin Pierce",
            "last_name": "Pierce",
            "first_name": "Hollin",
            "abbr_name": "H.Pierce",
            "birth_date": "2001-04-09",
            "weight": 344,
            "height": 80,
            "position": "OT",
            "birth_place": "Trenton, NJ, USA",
            "high_school": "Fork Union (VA)",
            "college": "Rutgers",
            "college_conf": "Big Ten Conference",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "b779251c-3250-405f-ae4a-3cadbf6925d9",
            "name": "Jalyx Hunt",
            "jersey": "58",
            "last_name": "Hunt",
            "first_name": "Jalyx",
            "abbr_name": "J.Hunt",
            "birth_date": "2001-03-13",
            "weight": 252,
            "height": 75,
            "position": "OLB",
            "birth_place": "DeBary, FL, USA",
            "high_school": "Dutch Fork (SC)",
            "college": "Houston Christian",
            "college_conf": "Southland Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:1768956",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 3,
                "number": 94,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "bcc0167c-05fd-4b23-981e-60b8784ceb33",
            "name": "Kylen Granson",
            "last_name": "Granson",
            "first_name": "Kylen",
            "abbr_name": "K.Granson",
            "birth_date": "1998-03-27",
            "weight": 242,
            "height": 75,
            "position": "TE",
            "birth_place": "Austin, TX, USA",
            "high_school": "Westlake (TX)",
            "college": "SMU",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2021,
            "status": "ACT",
            "sr_id": "sr:player:2198142",
            "experience": 4,
            "draft": {
                "year": 2021,
                "round": 4,
                "number": 127,
                "team": {
                    "id": "82cf9565-6eb9-4f01-bdbd-5aa0d472fcd9",
                    "name": "Colts",
                    "market": "Indianapolis",
                    "alias": "IND",
                    "sr_id": "sr:competitor:4421"
                }
            }
        },
        {
            "id": "c2cce6c0-e841-11ed-9d79-63f6ad42423a",
            "name": "Elijah Cooks",
            "last_name": "Cooks",
            "first_name": "Elijah",
            "abbr_name": "E.Cooks",
            "birth_date": "1998-10-13",
            "weight": 215,
            "height": 76,
            "position": "WR",
            "birth_place": "Atascadero, CA, USA",
            "high_school": "Atascadero (CA)",
            "college": "San Jose State",
            "college_conf": "Mountain West Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1236634",
            "experience": 2
        },
        {
            "id": "c603e45d-8112-4553-be24-42c3e0d858b5",
            "name": "Mac McWilliams",
            "last_name": "McWilliams",
            "first_name": "Mac",
            "abbr_name": "M.McWilliams",
            "birth_date": "2001-11-29",
            "weight": 191,
            "height": 70,
            "position": "CB",
            "birth_place": "Pensacola, FL, USA",
            "high_school": "Pine Forest (FL)",
            "college": "UCF",
            "college_conf": "Big Twelve Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 5,
                "number": 145,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "c9da2c23-478b-48a8-8a98-408caf3f0d16",
            "name": "Sydney Brown",
            "jersey": "21",
            "last_name": "Brown",
            "first_name": "Sydney",
            "abbr_name": "S.Brown",
            "birth_date": "2000-03-21",
            "weight": 211,
            "height": 70,
            "position": "SAF",
            "birth_place": "London, ON, CAN",
            "high_school": "Saint Stephen's (FL)",
            "college": "Illinois",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1436330",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 3,
                "number": 66,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "d0b809ac-b82a-4b66-98b1-9fcf613ace6c",
            "name": "Brett Toth",
            "jersey": "64",
            "last_name": "Toth",
            "first_name": "Brett",
            "abbr_name": "B.Toth",
            "birth_date": "1996-09-01",
            "weight": 304,
            "height": 78,
            "position": "OL",
            "birth_place": "Charleston, SC, USA",
            "high_school": "West Ashley (SC)",
            "college": "Army",
            "college_conf": "Independent",
            "rookie_year": 2019,
            "status": "ACT",
            "sr_id": "sr:player:1872480",
            "experience": 6
        },
        {
            "id": "d4506420-244f-11f0-802f-d5220dac29bc",
            "name": "Maxen Hook",
            "last_name": "Hook",
            "first_name": "Maxen",
            "abbr_name": "M.Hook",
            "birth_date": "2001-08-19",
            "weight": 203,
            "height": 72,
            "position": "SAF",
            "birth_place": "New Palestine, IN, USA",
            "high_school": "New Palestine (IN)",
            "college": "Toledo",
            "college_conf": "Mid-American Conference",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "d4a7917d-f327-431b-9b87-83af341c3e21",
            "name": "Jahan Dotson",
            "jersey": "83",
            "last_name": "Dotson",
            "first_name": "Jahan",
            "abbr_name": "J.Dotson",
            "birth_date": "2000-03-22",
            "weight": 184,
            "height": 71,
            "position": "WR",
            "birth_place": "Nazareth, PA, USA",
            "high_school": "Nazareth Area (PA)",
            "college": "Penn State",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1436296",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 1,
                "number": 16,
                "team": {
                    "id": "22052ff7-c065-42ee-bc8f-c4691c50e624",
                    "name": "Commanders",
                    "market": "Washington",
                    "alias": "WAS",
                    "sr_id": "sr:competitor:4432"
                }
            }
        },
        {
            "id": "d57e75e5-bd90-41be-97e9-c2d2cea5512b",
            "name": "Jihaad Campbell",
            "last_name": "Campbell",
            "first_name": "Jihaad",
            "abbr_name": "J.Campbell",
            "birth_date": "2004-02-24",
            "weight": 235,
            "height": 75,
            "position": "LB",
            "birth_place": "Erial, NJ, USA",
            "high_school": "IMG Academy (FL)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 0,
            "status": "UDF",
            "experience": 0,
            "draft": {
                "year": 2025,
                "round": 1,
                "number": 31,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "d606b6ee-de91-44cb-aebf-87f81daa14d2",
            "name": "Byron Young",
            "jersey": "94",
            "last_name": "Young",
            "first_name": "Byron",
            "abbr_name": "B.Young",
            "birth_date": "2000-11-10",
            "weight": 292,
            "height": 75,
            "position": "DT",
            "birth_place": "Laurel, MS, USA",
            "high_school": "West Jones (MS)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1834606",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 3,
                "number": 70,
                "team": {
                    "id": "7d4fcc64-9cb5-4d1b-8e75-8a906d1e1576",
                    "name": "Raiders",
                    "market": "Las Vegas",
                    "alias": "LV",
                    "sr_id": "sr:competitor:4390"
                }
            }
        },
        {
            "id": "d66ae3ad-8a60-47e7-a3b2-18a1e8377e1b",
            "name": "Dorian Thompson-Robinson",
            "last_name": "Thompson-Robinson",
            "first_name": "Dorian",
            "abbr_name": "D.Thompson-Robinson",
            "birth_date": "1999-11-14",
            "weight": 203,
            "height": 74,
            "position": "QB",
            "birth_place": "Columbia, SC, USA",
            "high_school": "Bishop Gorman (NV)",
            "college": "UCLA",
            "college_conf": "Pacific Twelve Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1437780",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 5,
                "number": 140,
                "team": {
                    "id": "d5a2eb42-8065-4174-ab79-0a6fa820e35e",
                    "name": "Browns",
                    "market": "Cleveland",
                    "alias": "CLE",
                    "sr_id": "sr:competitor:4417"
                }
            }
        },
        {
            "id": "e10bfeb8-ea01-47bc-bfa8-45f6dcbf71b3",
            "name": "A.J. Dillon",
            "jersey": "29",
            "last_name": "Dillon",
            "first_name": "A.J.",
            "abbr_name": "A.Dillon",
            "birth_date": "1998-05-02",
            "weight": 247,
            "height": 72,
            "position": "RB",
            "birth_place": "New London, CT, USA",
            "high_school": "Lawrence Academy (MA)",
            "college": "Boston College",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:2040055",
            "experience": 5,
            "draft": {
                "year": 2020,
                "round": 2,
                "number": 62,
                "team": {
                    "id": "a20471b4-a8d9-40c7-95ad-90cc30e46932",
                    "name": "Packers",
                    "market": "Green Bay",
                    "alias": "GB",
                    "sr_id": "sr:competitor:4420"
                }
            }
        },
        {
            "id": "e7fd0db0-2450-11f0-9355-ab13517f07bb",
            "name": "Brandon Johnson",
            "last_name": "Johnson",
            "first_name": "Brandon",
            "abbr_name": "B.Johnson",
            "weight": 185,
            "height": 70,
            "position": "DB",
            "birth_place": "Newton, NC, USA",
            "high_school": "Newton-Conover (NC)",
            "college": "Oregon",
            "college_conf": "Big Ten Conference",
            "rookie_year": 0,
            "status": "ACT",
            "experience": 0
        },
        {
            "id": "e8029983-87cf-49a2-bc04-04c8233a0630",
            "name": "Dallas Goedert",
            "jersey": "88",
            "last_name": "Goedert",
            "first_name": "Dallas",
            "abbr_name": "D.Goedert",
            "birth_date": "1995-01-03",
            "weight": 256,
            "height": 77,
            "position": "TE",
            "birth_place": "Britton, SD, USA",
            "high_school": "Britton-Hecla (SD)",
            "college": "South Dakota State",
            "college_conf": "Missouri Valley Football Conference",
            "rookie_year": 2018,
            "status": "ACT",
            "sr_id": "sr:player:1198888",
            "experience": 7,
            "draft": {
                "year": 2018,
                "round": 2,
                "number": 49,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "e8d389b5-56c8-4276-9983-0dbcc1663507",
            "name": "Johnny Wilson",
            "jersey": "89",
            "last_name": "Wilson",
            "first_name": "Johnny",
            "abbr_name": "J.Wilson",
            "birth_date": "2001-04-03",
            "weight": 228,
            "height": 78,
            "position": "WR",
            "birth_place": "Pacoima, CA, USA",
            "high_school": "Calabasas (CA)",
            "college": "Florida State",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:2093452",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 6,
                "number": 185,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "e9194ad2-d400-4dfe-9f4f-8b984537df60",
            "name": "Nolan Smith Jr.",
            "jersey": "3",
            "last_name": "Smith",
            "first_name": "Nolan",
            "abbr_name": "N.Smith",
            "birth_date": "2001-01-18",
            "weight": 238,
            "height": 74,
            "position": "OLB",
            "birth_place": "Savannah, GA, USA",
            "high_school": "IMG Academy (FL)",
            "college": "Georgia",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1693721",
            "name_suffix": "Jr.",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 1,
                "number": 30,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "f1a6c070-572e-4728-b5ab-7765bb31f9e2",
            "name": "Tyler Steen",
            "jersey": "56",
            "last_name": "Steen",
            "first_name": "Tyler",
            "abbr_name": "T.Steen",
            "birth_date": "2000-06-24",
            "weight": 321,
            "height": 78,
            "position": "OL",
            "birth_place": "Miami, FL, USA",
            "high_school": "St. Thomas Aquinas (FL)",
            "college": "Alabama",
            "college_conf": "Southeastern Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1413365",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 3,
                "number": 65,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "f1dd548b-fcdf-4819-8c5e-6fff3d29a2f9",
            "name": "KJ Henry",
            "jersey": "50",
            "last_name": "Henry",
            "first_name": "KJ",
            "abbr_name": "K.Henry",
            "birth_date": "1999-01-27",
            "weight": 255,
            "height": 76,
            "position": "DE",
            "birth_place": "Winston-Salem, NC, USA",
            "high_school": "West Forsyth (NC)",
            "college": "Clemson",
            "college_conf": "Atlantic Coast Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1410397",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 5,
                "number": 137,
                "team": {
                    "id": "22052ff7-c065-42ee-bc8f-c4691c50e624",
                    "name": "Commanders",
                    "market": "Washington",
                    "alias": "WAS",
                    "sr_id": "sr:competitor:4432"
                }
            }
        },
        {
            "id": "f213bbc9-1294-4bce-84b0-3752e63ff363",
            "name": "Cooper DeJean",
            "jersey": "33",
            "last_name": "DeJean",
            "first_name": "Cooper",
            "abbr_name": "C.DeJean",
            "birth_date": "2003-02-09",
            "weight": 198,
            "height": 72,
            "position": "DB",
            "birth_place": "Odebolt, IA, USA",
            "high_school": "OA-BCIG (IA)",
            "college": "Iowa",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2024,
            "status": "ACT",
            "sr_id": "sr:player:2795673",
            "experience": 0,
            "draft": {
                "year": 2024,
                "round": 2,
                "number": 40,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        },
        {
            "id": "f333e5c7-0cab-4876-9f37-0e70a3175d04",
            "name": "Ochaun Mathis",
            "jersey": "45",
            "last_name": "Mathis",
            "first_name": "Ochaun",
            "abbr_name": "O.Mathis",
            "birth_date": "1999-01-08",
            "weight": 260,
            "height": 77,
            "position": "OLB",
            "birth_place": "Manor, TX, USA",
            "high_school": "Manor (TX)",
            "college": "Nebraska",
            "college_conf": "Big Ten Conference",
            "rookie_year": 2023,
            "status": "ACT",
            "sr_id": "sr:player:1434905",
            "experience": 2,
            "draft": {
                "year": 2023,
                "round": 6,
                "number": 189,
                "team": {
                    "id": "2eff2a03-54d4-46ba-890e-2bc3925548f3",
                    "name": "Rams",
                    "market": "Los Angeles",
                    "alias": "LA",
                    "sr_id": "sr:competitor:4387"
                }
            }
        },
        {
            "id": "f58a5899-8b78-46e8-a29a-ba6273b7d872",
            "name": "Harrison Bryant",
            "last_name": "Bryant",
            "first_name": "Harrison",
            "abbr_name": "H.Bryant",
            "birth_date": "1998-04-23",
            "weight": 243,
            "height": 77,
            "position": "TE",
            "birth_place": "Gray, GA, USA",
            "high_school": "John Milledge Academy (GA)",
            "college": "Florida Atlantic",
            "college_conf": "Conference USA",
            "rookie_year": 2020,
            "status": "ACT",
            "sr_id": "sr:player:2040255",
            "experience": 5,
            "draft": {
                "year": 2020,
                "round": 4,
                "number": 115,
                "team": {
                    "id": "d5a2eb42-8065-4174-ab79-0a6fa820e35e",
                    "name": "Browns",
                    "market": "Cleveland",
                    "alias": "CLE",
                    "sr_id": "sr:competitor:4417"
                }
            }
        },
        {
            "id": "f67efd90-ce17-11ec-bebb-4fec1e38b0e5",
            "name": "Reed Blankenship",
            "jersey": "32",
            "last_name": "Blankenship",
            "first_name": "Reed",
            "abbr_name": "R.Blankenship",
            "birth_date": "1999-03-02",
            "weight": 203,
            "height": 73,
            "position": "SAF",
            "birth_place": "Athens, AL, USA",
            "high_school": "West Limestone (AL)",
            "college": "Middle Tennessee",
            "college_conf": "Conference USA",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1236166",
            "experience": 3
        },
        {
            "id": "f6988cfa-2dcf-490b-ac80-9af8e4292efa",
            "name": "Grant Calcaterra",
            "jersey": "81",
            "last_name": "Calcaterra",
            "first_name": "Grant",
            "abbr_name": "G.Calcaterra",
            "birth_date": "1998-12-04",
            "weight": 240,
            "height": 76,
            "position": "TE",
            "birth_place": "Rancho Santa Margarita, CA, USA",
            "high_school": "Santa Margarita (CA)",
            "college": "SMU",
            "college_conf": "American Athletic Conference",
            "rookie_year": 2022,
            "status": "ACT",
            "sr_id": "sr:player:1234414",
            "experience": 3,
            "draft": {
                "year": 2022,
                "round": 6,
                "number": 198,
                "team": {
                    "id": "386bdbf9-9eea-4869-bb9a-274b0bc66e80",
                    "name": "Eagles",
                    "market": "Philadelphia",
                    "alias": "PHI",
                    "sr_id": "sr:competitor:4428"
                }
            }
        }
    ],
    "_comment": "Generation started @ 2025-05-01 18:06:26 UTC ended @ 2025-05-01 18:06:26 UTC"
    }
}